import {Coordinates} from 'adhan';

export type TCity = {
	id: string,
	name: string,
	coordinate: Coordinates
}
export type TStates = {
	name: string,
	cities: TCity[]
}

export const stateCities: TStates[] = [
	{
		name: 'اردبيل',
		cities: [
			{
				id: 'اردبيل',
				name: 'اردبيل',
				coordinate: new Coordinates(38.2497444152832, 48.2942848205566)
			},
			{
				id: 'اصلاندوز',
				name: 'اصلاندوز',
				coordinate: new Coordinates(39.4426040649414, 47.4100227355957)
			},
			{
				id: 'آبي بيگلو',
				name: 'آبي بيگلو',
				coordinate: new Coordinates(38.2848968505859, 48.5525054931641)
			},
			{
				id: 'بيله سوار',
				name: 'بيله سوار',
				coordinate: new Coordinates(39.3760795593262, 48.3427085876465)
			},
			{
				id: 'پارس آباد',
				name: 'پارس آباد',
				coordinate: new Coordinates(39.6457939147949, 47.9099502563477)
			},
			{
				id: 'تازه كند',
				name: 'تازه كند',
				coordinate: new Coordinates(39.5755882263184, 48.0163764953613)
			},
			{
				id: 'تازه كندانگوت',
				name: 'تازه كندانگوت',
				coordinate: new Coordinates(39.0409660339355, 47.74365234375)
			},
			{
				id: 'جعفرآباد',
				name: 'جعفرآباد',
				coordinate: new Coordinates(39.433177947998, 48.0978813171387)
			},
			{
				id: 'خلخال',
				name: 'خلخال',
				coordinate: new Coordinates(37.6207504272461, 48.5273666381836)
			},
			{
				id: 'رضي',
				name: 'رضي',
				coordinate: new Coordinates(38.629020690918, 48.0945091247559)
			},
			{
				id: 'سرعين',
				name: 'سرعين',
				coordinate: new Coordinates(38.1376686096191, 48.0762329101563)
			},
			{
				id: 'عنبران',
				name: 'عنبران',
				coordinate: new Coordinates(38.4876899719238, 48.4351425170898)
			},
			{
				id: 'فخرآباد',
				name: 'فخرآباد',
				coordinate: new Coordinates(38.5229873657227, 47.8616714477539)
			},
			{
				id: 'كلور',
				name: 'كلور',
				coordinate: new Coordinates(37.3894538879395, 48.7229042053223)
			},
			{
				id: 'كوراييم',
				name: 'كوراييم',
				coordinate: new Coordinates(37.950569152832, 48.2355155944824)
			},
			{
				id: 'گرمي',
				name: 'گرمي',
				coordinate: new Coordinates(39.0121879577637, 48.0836029052734)
			},
			{
				id: 'گيوي',
				name: 'گيوي',
				coordinate: new Coordinates(37.6841621398926, 48.3396682739258)
			},
			{
				id: 'لاهرود',
				name: 'لاهرود',
				coordinate: new Coordinates(38.5073356628418, 47.8304786682129)
			},
			{
				id: 'مرادلو',
				name: 'مرادلو',
				coordinate: new Coordinates(38.7467613220215, 47.7462844848633)
			},
			{
				id: 'مشگين شهر',
				name: 'مشگين شهر',
				coordinate: new Coordinates(38.3971862792969, 47.6725807189941)
			},
			{
				id: 'نمين',
				name: 'نمين',
				coordinate: new Coordinates(38.4236488342285, 48.4808197021484)
			},
			{
				id: 'نير',
				name: 'نير',
				coordinate: new Coordinates(38.0352172851562, 48.0073928833008)
			},
			{
				id: 'هشتجين',
				name: 'هشتجين',
				coordinate: new Coordinates(37.363826751709, 48.3245849609375)
			},
			{
				id: 'هير',
				name: 'هير',
				coordinate: new Coordinates(38.0753555297852, 48.497974395752)
			}
		]
	},
	{
		name: 'اصفهان',
		cities: [
			{
				id: 'ابريشم',
				name: 'ابريشم',
				coordinate: new Coordinates(32.5561141967773, 51.5736312866211)
			},
			{
				id: 'ابوزيدآباد',
				name: 'ابوزيدآباد',
				coordinate: new Coordinates(33.9041328430176, 51.7680015563965)
			},
			{
				id: 'اردستان',
				name: 'اردستان',
				coordinate: new Coordinates(33.3565788269043, 52.3781852722168)
			},
			{
				id: 'اژيه',
				name: 'اژيه',
				coordinate: new Coordinates(32.4401702880859, 52.3795166015625)
			},
			{
				id: 'اصفهان',
				name: 'اصفهان',
				coordinate: new Coordinates(32.57763671875, 51.6590538024902)
			},
			{
				id: 'افوس',
				name: 'افوس',
				coordinate: new Coordinates(33.0241394042969, 50.0929794311523)
			},
			{
				id: 'انارك',
				name: 'انارك',
				coordinate: new Coordinates(33.3068008422852, 53.6970291137695)
			},
			{
				id: 'ايمانشهر',
				name: 'ايمانشهر',
				coordinate: new Coordinates(32.4703483581543, 51.4613838195801)
			},
			{
				id: 'آران وبيدگل',
				name: 'آران وبيدگل',
				coordinate: new Coordinates(34.0581970214844, 51.4824867248535)
			},
			{
				id: 'بادرود',
				name: 'بادرود',
				coordinate: new Coordinates(33.6897506713867, 52.0112648010254)
			},
			{
				id: 'باغ بهادران',
				name: 'باغ بهادران',
				coordinate: new Coordinates(32.3758201599121, 51.1912422180176)
			},
			{
				id: 'بافران',
				name: 'بافران',
				coordinate: new Coordinates(32.8366813659668, 53.1421432495117)
			},
			{
				id: 'برزك',
				name: 'برزك',
				coordinate: new Coordinates(33.7783164978027, 51.230152130127)
			},
			{
				id: 'برف انبار',
				name: 'برف انبار',
				coordinate: new Coordinates(32.9958724975586, 50.1938819885254)
			},
			{
				id: 'بوئين ومياندشت',
				name: 'بوئين ومياندشت',
				coordinate: new Coordinates(33.0804443359375, 50.1587333679199)
			},
			{
				id: 'بهاران شهر',
				name: 'بهاران شهر',
				coordinate: new Coordinates(32.5156440734863, 51.5414428710938)
			},
			{
				id: 'بهارستان',
				name: 'بهارستان',
				coordinate: new Coordinates(32.4865112304687, 51.7789115905762)
			},
			{
				id: 'پيربكران',
				name: 'پيربكران',
				coordinate: new Coordinates(32.465576171875, 51.5559616088867)
			},
			{
				id: 'تودشك',
				name: 'تودشك',
				coordinate: new Coordinates(32.7282676696777, 52.6791152954102)
			},
			{
				id: 'تيران',
				name: 'تيران',
				coordinate: new Coordinates(32.704402923584, 51.1531791687012)
			},
			{
				id: 'جندق',
				name: 'جندق',
				coordinate: new Coordinates(34.0413131713867, 54.4144668579102)
			},
			{
				id: 'جوزدان',
				name: 'جوزدان',
				coordinate: new Coordinates(32.5548973083496, 51.3718605041504)
			},
			{
				id: 'جوشقان وكامو',
				name: 'جوشقان وكامو',
				coordinate: new Coordinates(33.5994682312012, 51.2282638549805)
			},
			{
				id: 'چادگان',
				name: 'چادگان',
				coordinate: new Coordinates(32.771556854248, 50.6268577575684)
			},
			{
				id: 'چرمهين',
				name: 'چرمهين',
				coordinate: new Coordinates(32.3383598327637, 51.1954879760742)
			},
			{
				id: 'چمگردان',
				name: 'چمگردان',
				coordinate: new Coordinates(32.3935050964355, 51.3353500366211)
			},
			{
				id: 'حبيب آباد',
				name: 'حبيب آباد',
				coordinate: new Coordinates(32.8218879699707, 51.7758712768555)
			},
			{
				id: 'حسن آباد',
				name: 'حسن آباد',
				coordinate: new Coordinates(32.1366348266602, 52.6235427856445)
			},
			{
				id: 'حنا',
				name: 'حنا',
				coordinate: new Coordinates(31.1975841522217, 51.7256813049316)
			},
			{
				id: 'خالدآباد',
				name: 'خالدآباد',
				coordinate: new Coordinates(33.7018356323242, 51.9816436767578)
			},
			{
				id: 'خميني شهر',
				name: 'خميني شهر',
				coordinate: new Coordinates(32.6833305358887, 51.5335960388184)
			},
			{
				id: 'خوانسار',
				name: 'خوانسار',
				coordinate: new Coordinates(33.2142295837402, 50.3188705444336)
			},
			{
				id: 'خور',
				name: 'خور',
				coordinate: new Coordinates(33.7718162536621, 55.0838432312012)
			},
			{
				id: 'خوراسگان',
				name: 'خوراسگان',
				coordinate: new Coordinates(32.655101776123, 51.7595481872559)
			},
			{
				id: 'خورزوق',
				name: 'خورزوق',
				coordinate: new Coordinates(32.7767219543457, 51.6498374938965)
			},
			{
				id: 'داران',
				name: 'داران',
				coordinate: new Coordinates(32.9862174987793, 50.4091377258301)
			},
			{
				id: 'دامنه',
				name: 'دامنه',
				coordinate: new Coordinates(33.0157928466797, 50.4877700805664)
			},
			{
				id: 'درچه پياز',
				name: 'درچه پياز',
				coordinate: new Coordinates(32.6044807434082, 51.5477066040039)
			},
			{
				id: 'دستگرد',
				name: 'دستگرد',
				coordinate: new Coordinates(32.8020477294922, 51.665714263916)
			},
			{
				id: 'دولت آباد',
				name: 'دولت آباد',
				coordinate: new Coordinates(32.8047294616699, 51.6935615539551)
			},
			{
				id: 'دهاقان',
				name: 'دهاقان',
				coordinate: new Coordinates(31.9331302642822, 51.6541786193848)
			},
			{
				id: 'دهق',
				name: 'دهق',
				coordinate: new Coordinates(33.103385925293, 50.9591751098633)
			},
			{
				id: 'ديزيچه',
				name: 'ديزيچه',
				coordinate: new Coordinates(32.3779296875, 51.5041618347168)
			},
			{
				id: 'رزوه',
				name: 'رزوه',
				coordinate: new Coordinates(32.8351287841797, 50.5693435668945)
			},
			{
				id: 'رضوانشهر',
				name: 'رضوانشهر',
				coordinate: new Coordinates(32.6997413635254, 51.1038818359375)
			},
			{
				id: 'زاينده رود',
				name: 'زاينده رود',
				coordinate: new Coordinates(32.3782157897949, 51.2732620239258)
			},
			{
				id: 'زرين شهر',
				name: 'زرين شهر',
				coordinate: new Coordinates(32.3941307067871, 51.3858947753906)
			},
			{
				id: 'زواره',
				name: 'زواره',
				coordinate: new Coordinates(33.4478607177734, 52.4866638183594)
			},
			{
				id: 'زيباشهر',
				name: 'زيباشهر',
				coordinate: new Coordinates(32.3794174194336, 51.5648231506348)
			},
			{
				id: 'سده لنجان',
				name: 'سده لنجان',
				coordinate: new Coordinates(32.3773918151855, 51.318904876709)
			},
			{
				id: 'سفيدشهر',
				name: 'سفيدشهر',
				coordinate: new Coordinates(34.1230621337891, 51.3515014648438)
			},
			{
				id: 'سگزي',
				name: 'سگزي',
				coordinate: new Coordinates(32.6685638427734, 52.1304664611816)
			},
			{
				id: 'سميرم',
				name: 'سميرم',
				coordinate: new Coordinates(31.4145526885986, 51.5718688964844)
			},
			{
				id: 'شاپورآباد',
				name: 'شاپورآباد',
				coordinate: new Coordinates(32.8454208374023, 51.7433204650879)
			},
			{
				id: 'شاهين شهر',
				name: 'شاهين شهر',
				coordinate: new Coordinates(32.8643188476562, 51.5546760559082)
			},
			{
				id: 'شهرضا',
				name: 'شهرضا',
				coordinate: new Coordinates(31.9766597747803, 51.8494262695313)
			},
			{
				id: 'طالخونچه',
				name: 'طالخونچه',
				coordinate: new Coordinates(32.2620849609375, 51.5642776489258)
			},
			{
				id: 'عسگران',
				name: 'عسگران',
				coordinate: new Coordinates(32.863525390625, 50.8521995544434)
			},
			{
				id: 'علويچه',
				name: 'علويچه',
				coordinate: new Coordinates(33.054801940918, 51.0814590454102)
			},
			{
				id: 'فرخي',
				name: 'فرخي',
				coordinate: new Coordinates(33.8445816040039, 54.9468803405762)
			},
			{
				id: 'فريدونشهر',
				name: 'فريدونشهر',
				coordinate: new Coordinates(32.9399871826172, 50.1393852233887)
			},
			{
				id: 'فلاورجان',
				name: 'فلاورجان',
				coordinate: new Coordinates(32.556266784668, 51.506290435791)
			},
			{
				id: 'فولادشهر',
				name: 'فولادشهر',
				coordinate: new Coordinates(32.4895324707031, 51.4073677062988)
			},
			{
				id: 'قمصر',
				name: 'قمصر',
				coordinate: new Coordinates(33.752010345459, 51.4306488037109)
			},
			{
				id: 'قهجاورستان',
				name: 'قهجاورستان',
				coordinate: new Coordinates(32.7031364440918, 51.8350067138672)
			},
			{
				id: 'قهدريجان',
				name: 'قهدريجان',
				coordinate: new Coordinates(32.5738372802734, 51.4558486938477)
			},
			{
				id: 'كاشان',
				name: 'كاشان',
				coordinate: new Coordinates(33.9833946228027, 51.4320831298828)
			},
			{
				id: 'كركوند',
				name: 'كركوند',
				coordinate: new Coordinates(32.3462944030762, 51.4372367858887)
			},
			{
				id: 'كليشادوسودرجان',
				name: 'كليشادوسودرجان',
				coordinate: new Coordinates(32.5415382385254, 51.5358963012695)
			},
			{
				id: 'كمشچه',
				name: 'كمشچه',
				coordinate: new Coordinates(32.9057693481445, 51.8090400695801)
			},
			{
				id: 'كمه',
				name: 'كمه',
				coordinate: new Coordinates(31.061466217041, 51.5935821533203)
			},
			{
				id: 'كوشك',
				name: 'كوشك',
				coordinate: new Coordinates(32.640079498291, 51.5001068115234)
			},
			{
				id: 'كوهپايه',
				name: 'كوهپايه',
				coordinate: new Coordinates(32.7151107788086, 52.4325180053711)
			},
			{
				id: 'كهريزسنگ',
				name: 'كهريزسنگ',
				coordinate: new Coordinates(32.6262474060059, 51.4771156311035)
			},
			{
				id: 'گرگاب',
				name: 'گرگاب',
				coordinate: new Coordinates(32.8657684326172, 51.5976524353027)
			},
			{
				id: 'گزبرخوار',
				name: 'گزبرخوار',
				coordinate: new Coordinates(32.8046073913574, 51.6188278198242)
			},
			{
				id: 'گلپايگان',
				name: 'گلپايگان',
				coordinate: new Coordinates(33.4509506225586, 50.2833633422852)
			},
			{
				id: 'گلدشت',
				name: 'گلدشت',
				coordinate: new Coordinates(32.6299057006836, 51.4427185058594)
			},
			{
				id: 'گلشن',
				name: 'گلشن',
				coordinate: new Coordinates(31.929220199585, 51.7525062561035)
			},
			{
				id: 'گلشهر',
				name: 'گلشهر',
				coordinate: new Coordinates(33.5058822631836, 50.4656143188477)
			},
			{
				id: 'گوگد',
				name: 'گوگد',
				coordinate: new Coordinates(33.473445892334, 50.3453140258789)
			},
			{
				id: 'لاي بيد',
				name: 'لاي بيد',
				coordinate: new Coordinates(33.4586524963379, 50.694149017334)
			},
			{
				id: 'مباركه',
				name: 'مباركه',
				coordinate: new Coordinates(32.3417739868164, 51.5006828308106)
			},
			{
				id: 'محمدآباد',
				name: 'محمدآباد',
				coordinate: new Coordinates(32.3194541931152, 52.1039123535156)
			},
			{
				id: 'مشكات',
				name: 'مشكات',
				coordinate: new Coordinates(34.1753463745117, 51.2682571411133)
			},
			{
				id: 'منظريه',
				name: 'منظريه',
				coordinate: new Coordinates(31.9432907104492, 51.872127532959)
			},
			{
				id: 'مهاباد',
				name: 'مهاباد',
				coordinate: new Coordinates(33.5276565551758, 52.2173271179199)
			},
			{
				id: 'ميمه',
				name: 'ميمه',
				coordinate: new Coordinates(33.4467430114746, 51.1703453063965)
			},
			{
				id: 'نائين',
				name: 'نائين',
				coordinate: new Coordinates(32.8604469299316, 53.0956153869629)
			},
			{
				id: 'نجف آباد',
				name: 'نجف آباد',
				coordinate: new Coordinates(32.631534576416, 51.3505897521973)
			},
			{
				id: 'نصرآباد',
				name: 'نصرآباد',
				coordinate: new Coordinates(32.2783546447754, 52.0619697570801)
			},
			{
				id: 'نطنز',
				name: 'نطنز',
				coordinate: new Coordinates(33.5046806335449, 51.9190711975098)
			},
			{
				id: 'نوش آباد',
				name: 'نوش آباد',
				coordinate: new Coordinates(34.0808258056641, 51.4379463195801)
			},
			{
				id: 'نياسر',
				name: 'نياسر',
				coordinate: new Coordinates(33.9724502563477, 51.1489105224609)
			},
			{
				id: 'نيك آباد',
				name: 'نيك آباد',
				coordinate: new Coordinates(32.3027839660645, 52.205207824707)
			},
			{
				id: 'ورزنه',
				name: 'ورزنه',
				coordinate: new Coordinates(32.4203186035156, 52.6506118774414)
			},
			{
				id: 'ورنامخواست',
				name: 'ورنامخواست',
				coordinate: new Coordinates(32.3549575805664, 51.3801193237305)
			},
			{
				id: 'وزوان',
				name: 'وزوان',
				coordinate: new Coordinates(33.4198913574219, 51.1833381652832)
			},
			{
				id: 'ونك',
				name: 'ونك',
				coordinate: new Coordinates(31.5282421112061, 51.326473236084)
			},
			{
				id: 'هرند',
				name: 'هرند',
				coordinate: new Coordinates(32.5638618469238, 52.4372901916504)
			}
		]
	},
	{
		name: 'البرز',
		cities: [
			{
				id: 'اشتهارد',
				name: 'اشتهارد',
				coordinate: new Coordinates(35.7245903015137, 50.3614768981934)
			},
			{
				id: 'آسارا',
				name: 'آسارا',
				coordinate: new Coordinates(36.0314483642578, 51.1738739013672)
			},
			{
				id: 'تنكمان',
				name: 'تنكمان',
				coordinate: new Coordinates(35.8894081115723, 50.6148834228516)
			},
			{
				id: 'چهارباغ',
				name: 'چهارباغ',
				coordinate: new Coordinates(35.8381538391113, 50.8479804992676)
			},
			{
				id: 'سيف آباد',
				name: 'سيف آباد',
				coordinate: new Coordinates(35.9114799499512, 50.7705383300781)
			},
			{
				id: 'شهرجديدهشتگرد',
				name: 'شهرجديدهشتگرد',
				coordinate: new Coordinates(35.9842948913574, 50.7412033081055)
			},
			{
				id: 'طالقان',
				name: 'طالقان',
				coordinate: new Coordinates(36.1729965209961, 50.7684898376465)
			},
			{
				id: 'كرج',
				name: 'كرج',
				coordinate: new Coordinates(35.7247200012207, 50.952766418457)
			},
			{
				id: 'كمال شهر',
				name: 'كمال شهر',
				coordinate: new Coordinates(35.8460388183594, 50.8840484619141)
			},
			{
				id: 'كوهسار',
				name: 'كوهسار',
				coordinate: new Coordinates(35.9556694030762, 50.7935333251953)
			},
			{
				id: 'گرمدره',
				name: 'گرمدره',
				coordinate: new Coordinates(35.7445411682129, 51.0688552856445)
			},
			{
				id: 'ماهدشت',
				name: 'ماهدشت',
				coordinate: new Coordinates(35.7275619506836, 50.8061294555664)
			},
			{
				id: 'محمدشهر',
				name: 'محمدشهر',
				coordinate: new Coordinates(35.736644744873, 50.8995513916016)
			},
			{
				id: 'مشكين دشت',
				name: 'مشكين دشت',
				coordinate: new Coordinates(35.7483863830566, 50.9407806396484)
			},
			{
				id: 'نظرآباد',
				name: 'نظرآباد',
				coordinate: new Coordinates(35.9519500732422, 50.6045341491699)
			},
			{
				id: 'هشتگرد',
				name: 'هشتگرد',
				coordinate: new Coordinates(35.95068359375, 50.6838607788086)
			}
		]
	},
	{
		name: 'ايلام',
		cities: [
			{
				id: 'اركواز',
				name: 'اركواز',
				coordinate: new Coordinates(33.3871078491211, 46.5977249145508)
			},
			{
				id: 'ايلام',
				name: 'ايلام',
				coordinate: new Coordinates(33.5750541687012, 46.4164161682129)
			},
			{
				id: 'ايوان',
				name: 'ايوان',
				coordinate: new Coordinates(33.8293533325195, 46.3061294555664)
			},
			{
				id: 'آبدانان',
				name: 'آبدانان',
				coordinate: new Coordinates(32.988353729248, 47.4240951538086)
			},
			{
				id: 'آسمان آباد',
				name: 'آسمان آباد',
				coordinate: new Coordinates(33.8493843078613, 46.4656257629395)
			},
			{
				id: 'بدره',
				name: 'بدره',
				coordinate: new Coordinates(33.3071708679199, 47.038330078125)
			},
			{
				id: 'پهله',
				name: 'پهله',
				coordinate: new Coordinates(33.0114555358887, 46.8835563659668)
			},
			{
				id: 'توحيد',
				name: 'توحيد',
				coordinate: new Coordinates(33.7268218994141, 47.0682945251465)
			},
			{
				id: 'چوار',
				name: 'چوار',
				coordinate: new Coordinates(33.6919097900391, 46.2971534729004)
			},
			{
				id: 'دره شهر',
				name: 'دره شهر',
				coordinate: new Coordinates(33.149486541748, 47.3816604614258)
			},
			{
				id: 'دلگشا',
				name: 'دلگشا',
				coordinate: new Coordinates(33.4057121276855, 46.5942878723145)
			},
			{
				id: 'دهلران',
				name: 'دهلران',
				coordinate: new Coordinates(32.6902008056641, 47.2708549499512)
			},
			{
				id: 'زرنه',
				name: 'زرنه',
				coordinate: new Coordinates(33.926212310791, 46.1867218017578)
			},
			{
				id: 'سراب باغ',
				name: 'سراب باغ',
				coordinate: new Coordinates(32.896671295166, 47.5726318359375)
			},
			{
				id: 'سرابله',
				name: 'سرابله',
				coordinate: new Coordinates(33.7682266235352, 46.5613670349121)
			},
			{
				id: 'صالح آباد',
				name: 'صالح آباد',
				coordinate: new Coordinates(33.4687728881836, 46.1910667419434)
			},
			{
				id: 'لومار',
				name: 'لومار',
				coordinate: new Coordinates(33.5671844482422, 46.8113555908203)
			},
			{
				id: 'مورموري',
				name: 'مورموري',
				coordinate: new Coordinates(32.726318359375, 47.6750984191895)
			},
			{
				id: 'موسيان',
				name: 'موسيان',
				coordinate: new Coordinates(32.5201835632324, 47.3770713806152)
			},
			{
				id: 'مهران',
				name: 'مهران',
				coordinate: new Coordinates(33.1220283508301, 46.1728897094727)
			},
			{
				id: 'ميمه',
				name: 'ميمه',
				coordinate: new Coordinates(33.2266235351562, 46.9186477661133)
			}
		]
	},
	{
		name: 'آذربايجان شرقي',
		cities: [
			{
				id: 'اسكو',
				name: 'اسكو',
				coordinate: new Coordinates(37.917781829834, 46.1244697570801)
			},
			{
				id: 'اهر',
				name: 'اهر',
				coordinate: new Coordinates(38.4745330810547, 47.0709838867188)
			},
			{
				id: 'ايلخچي',
				name: 'ايلخچي',
				coordinate: new Coordinates(37.9367408752441, 45.9819869995117)
			},
			{
				id: 'آبش احمد',
				name: 'آبش احمد',
				coordinate: new Coordinates(39.0401382446289, 47.3173637390137)
			},
			{
				id: 'آذرشهر',
				name: 'آذرشهر',
				coordinate: new Coordinates(37.7661781311035, 45.976448059082)
			},
			{
				id: 'آقكند',
				name: 'آقكند',
				coordinate: new Coordinates(37.2533721923828, 48.0654716491699)
			},
			{
				id: 'باسمنج',
				name: 'باسمنج',
				coordinate: new Coordinates(37.9943542480469, 46.4747467041016)
			},
			{
				id: 'بخشايش',
				name: 'بخشايش',
				coordinate: new Coordinates(38.1318511962891, 46.9474678039551)
			},
			{
				id: 'بستان آباد',
				name: 'بستان آباد',
				coordinate: new Coordinates(37.8369941711426, 46.8309631347656)
			},
			{
				id: 'بناب',
				name: 'بناب',
				coordinate: new Coordinates(37.345588684082, 46.0662002563477)
			},
			{
				id: 'بناب جديد',
				name: 'بناب جديد',
				coordinate: new Coordinates(38.4233055114746, 45.9070091247559)
			},
			{
				id: 'تبريز',
				name: 'تبريز',
				coordinate: new Coordinates(38.0792922973633, 46.2891502380371)
			},
			{
				id: 'ترك',
				name: 'ترك',
				coordinate: new Coordinates(37.6076850891113, 47.7681884765625)
			},
			{
				id: 'تركمانچاي',
				name: 'تركمانچاي',
				coordinate: new Coordinates(37.5804405212402, 47.3914527893066)
			},
			{
				id: 'تسوج',
				name: 'تسوج',
				coordinate: new Coordinates(38.3105506896973, 45.3704147338867)
			},
			{
				id: 'تيكمه داش',
				name: 'تيكمه داش',
				coordinate: new Coordinates(37.7283897399902, 46.9458045959473)
			},
			{
				id: 'جلفا',
				name: 'جلفا',
				coordinate: new Coordinates(38.9347648620605, 45.6388702392578)
			},
			{
				id: 'خاروانا',
				name: 'خاروانا',
				coordinate: new Coordinates(38.6830024719238, 46.1686401367188)
			},
			{
				id: 'خامنه',
				name: 'خامنه',
				coordinate: new Coordinates(38.1939392089844, 45.6329574584961)
			},
			{
				id: 'خراجو',
				name: 'خراجو',
				coordinate: new Coordinates(37.3116493225098, 46.5315322875977)
			},
			{
				id: 'خسروشهر',
				name: 'خسروشهر',
				coordinate: new Coordinates(37.9543724060059, 46.0506858825684)
			},
			{
				id: 'خمارلو',
				name: 'خمارلو',
				coordinate: new Coordinates(39.1480102539062, 47.0347557067871)
			},
			{
				id: 'خواجه',
				name: 'خواجه',
				coordinate: new Coordinates(38.1546936035156, 46.5869102478027)
			},
			{
				id: 'دوزدوزان',
				name: 'دوزدوزان',
				coordinate: new Coordinates(37.949333190918, 47.1199645996094)
			},
			{
				id: 'زرنق',
				name: 'زرنق',
				coordinate: new Coordinates(38.0918426513672, 47.0817031860352)
			},
			{
				id: 'زنوز',
				name: 'زنوز',
				coordinate: new Coordinates(38.5879936218262, 45.8343887329102)
			},
			{
				id: 'سراب',
				name: 'سراب',
				coordinate: new Coordinates(37.9409980773926, 47.5353317260742)
			},
			{
				id: 'سردرود',
				name: 'سردرود',
				coordinate: new Coordinates(38.0317802429199, 46.1479148864746)
			},
			{
				id: 'سيس',
				name: 'سيس',
				coordinate: new Coordinates(38.1940765380859, 45.8140869140625)
			},
			{
				id: 'سيه رود',
				name: 'سيه رود',
				coordinate: new Coordinates(38.8695182800293, 46.0017051696777)
			},
			{
				id: 'شبستر',
				name: 'شبستر',
				coordinate: new Coordinates(38.1805000305176, 45.7013931274414)
			},
			{
				id: 'شربيان',
				name: 'شربيان',
				coordinate: new Coordinates(37.8815536499023, 47.0999603271484)
			},
			{
				id: 'شرفخانه',
				name: 'شرفخانه',
				coordinate: new Coordinates(38.1778373718262, 45.4902572631836)
			},
			{
				id: 'شندآباد',
				name: 'شندآباد',
				coordinate: new Coordinates(38.1421356201172, 45.6225204467773)
			},
			{
				id: 'شهرجديدسهند',
				name: 'شهرجديدسهند',
				coordinate: new Coordinates(37.9450912475586, 46.1210098266602)
			},
			{
				id: 'صوفيان',
				name: 'صوفيان',
				coordinate: new Coordinates(38.278621673584, 45.981616973877)
			},
			{
				id: 'عجب شير',
				name: 'عجب شير',
				coordinate: new Coordinates(37.4771003723145, 45.894832611084)
			},
			{
				id: 'قره آغاج',
				name: 'قره آغاج',
				coordinate: new Coordinates(37.1291007995605, 46.9722404479981)
			},
			{
				id: 'كشكسراي',
				name: 'كشكسراي',
				coordinate: new Coordinates(38.4600524902344, 45.5689353942871)
			},
			{
				id: 'كلوانق',
				name: 'كلوانق',
				coordinate: new Coordinates(38.1012496948242, 46.9931907653809)
			},
			{
				id: 'كليبر',
				name: 'كليبر',
				coordinate: new Coordinates(38.8648490905762, 47.0407829284668)
			},
			{
				id: 'كوزه كنان',
				name: 'كوزه كنان',
				coordinate: new Coordinates(38.1838035583496, 45.5774917602539)
			},
			{
				id: 'گوگان',
				name: 'گوگان',
				coordinate: new Coordinates(37.7691345214844, 45.9045715332031)
			},
			{
				id: 'ليلان',
				name: 'ليلان',
				coordinate: new Coordinates(37.0064506530762, 46.20556640625)
			},
			{
				id: 'مراغه',
				name: 'مراغه',
				coordinate: new Coordinates(37.3860359191895, 46.2336044311523)
			},
			{
				id: 'مرند',
				name: 'مرند',
				coordinate: new Coordinates(38.4319381713867, 45.772045135498)
			},
			{
				id: 'ملكان',
				name: 'ملكان',
				coordinate: new Coordinates(37.1425323486328, 46.1003761291504)
			},
			{
				id: 'ممقان',
				name: 'ممقان',
				coordinate: new Coordinates(37.8386344909668, 45.9715576171875)
			},
			{
				id: 'مهربان',
				name: 'مهربان',
				coordinate: new Coordinates(38.0815925598145, 47.1316719055176)
			},
			{
				id: 'ميانه',
				name: 'ميانه',
				coordinate: new Coordinates(37.4207077026367, 47.7163505554199)
			},
			{
				id: 'نظركهريزي',
				name: 'نظركهريزي',
				coordinate: new Coordinates(37.3473129272461, 46.7620849609375)
			},
			{
				id: 'وايقان',
				name: 'وايقان',
				coordinate: new Coordinates(38.1308403015137, 45.7127838134766)
			},
			{
				id: 'ورزقان',
				name: 'ورزقان',
				coordinate: new Coordinates(38.5087051391602, 46.6503448486328)
			},
			{
				id: 'هاديشهر',
				name: 'هاديشهر',
				coordinate: new Coordinates(38.8384284973145, 45.6629066467285)
			},
			{
				id: 'هريس',
				name: 'هريس',
				coordinate: new Coordinates(38.2496223449707, 47.1171188354492)
			},
			{
				id: 'هشترود',
				name: 'هشترود',
				coordinate: new Coordinates(37.470775604248, 47.0596694946289)
			},
			{
				id: 'هوراند',
				name: 'هوراند',
				coordinate: new Coordinates(38.8571891784668, 47.3651275634766)
			},
			{
				id: 'يامچي',
				name: 'يامچي',
				coordinate: new Coordinates(38.5216598510742, 45.6402587890625)
			}
		]
	},
	{
		name: 'آذربايجان غربي',
		cities: [
			{
				id: 'اروميه',
				name: 'اروميه',
				coordinate: new Coordinates(37.5395393371582, 45.0576515197754)
			},
			{
				id: 'اشنويه',
				name: 'اشنويه',
				coordinate: new Coordinates(37.040210723877, 45.1000442504883)
			},
			{
				id: 'ايواوغلي',
				name: 'ايواوغلي',
				coordinate: new Coordinates(38.7186546325684, 45.2114105224609)
			},
			{
				id: 'آواجيق',
				name: 'آواجيق',
				coordinate: new Coordinates(39.3317375183105, 44.1531105041504)
			},
			{
				id: 'باروق',
				name: 'باروق',
				coordinate: new Coordinates(36.9509696960449, 46.3199768066406)
			},
			{
				id: 'بازرگان',
				name: 'بازرگان',
				coordinate: new Coordinates(39.3942375183105, 44.3866882324219)
			},
			{
				id: 'بوكان',
				name: 'بوكان',
				coordinate: new Coordinates(36.5079879760742, 46.2066612243652)
			},
			{
				id: 'پلدشت',
				name: 'پلدشت',
				coordinate: new Coordinates(39.3478507995605, 45.0683708190918)
			},
			{
				id: 'پيرانشهر',
				name: 'پيرانشهر',
				coordinate: new Coordinates(36.6939392089844, 45.1411933898926)
			},
			{
				id: 'تازه شهر',
				name: 'تازه شهر',
				coordinate: new Coordinates(38.1757659912109, 44.6908111572266)
			},
			{
				id: 'تكاب',
				name: 'تكاب',
				coordinate: new Coordinates(36.4042205810547, 47.1101608276367)
			},
			{
				id: 'چهاربرج',
				name: 'چهاربرج',
				coordinate: new Coordinates(37.1257705688477, 45.9755630493164)
			},
			{
				id: 'خليفان',
				name: 'خليفان',
				coordinate: new Coordinates(36.5070877075195, 45.7964744567871)
			},
			{
				id: 'خوي',
				name: 'خوي',
				coordinate: new Coordinates(38.5202941894531, 44.9546546936035)
			},
			{
				id: 'ديزج ديز',
				name: 'ديزج ديز',
				coordinate: new Coordinates(38.4608955383301, 45.0234451293945)
			},
			{
				id: 'ربط',
				name: 'ربط',
				coordinate: new Coordinates(36.2112731933594, 45.5517425537109)
			},
			{
				id: 'سردشت',
				name: 'سردشت',
				coordinate: new Coordinates(36.153995513916, 45.4791145324707)
			},
			{
				id: 'سرو',
				name: 'سرو',
				coordinate: new Coordinates(37.7227325439453, 44.6504287719727)
			},
			{
				id: 'سلماس',
				name: 'سلماس',
				coordinate: new Coordinates(38.1987380981445, 44.7660293579102)
			},
			{
				id: 'سيلوانه',
				name: 'سيلوانه',
				coordinate: new Coordinates(37.4224281311035, 44.8513221740723)
			},
			{
				id: 'سيمينه',
				name: 'سيمينه',
				coordinate: new Coordinates(36.7256965637207, 46.1530685424805)
			},
			{
				id: 'سيه چشمه',
				name: 'سيه چشمه',
				coordinate: new Coordinates(39.0691795349121, 44.3874588012695)
			},
			{
				id: 'شاهين دژ',
				name: 'شاهين دژ',
				coordinate: new Coordinates(36.6792144775391, 46.566463470459)
			},
			{
				id: 'شوط',
				name: 'شوط',
				coordinate: new Coordinates(39.2181243896484, 44.7711219787598)
			},
			{
				id: 'فيرورق',
				name: 'فيرورق',
				coordinate: new Coordinates(38.5777816772461, 44.8367156982422)
			},
			{
				id: 'قره ضياءالدين',
				name: 'قره ضياءالدين',
				coordinate: new Coordinates(38.888542175293, 45.0251731872559)
			},
			{
				id: 'قطور',
				name: 'قطور',
				coordinate: new Coordinates(38.4734764099121, 44.4057006835938)
			},
			{
				id: 'قوشچي',
				name: 'قوشچي',
				coordinate: new Coordinates(37.9912071228027, 45.0378761291504)
			},
			{
				id: 'كشاورز',
				name: 'كشاورز',
				coordinate: new Coordinates(36.8347473144531, 46.3584327697754)
			},
			{
				id: 'گردكشانه',
				name: 'گردكشانه',
				coordinate: new Coordinates(36.8118896484375, 45.2739372253418)
			},
			{
				id: 'ماكو',
				name: 'ماكو',
				coordinate: new Coordinates(39.2921524047852, 44.4924354553223)
			},
			{
				id: 'محمديار',
				name: 'محمديار',
				coordinate: new Coordinates(36.9813995361328, 45.5221405029297)
			},
			{
				id: 'محمودآباد',
				name: 'محمودآباد',
				coordinate: new Coordinates(36.7118759155273, 46.5190086364746)
			},
			{
				id: 'مهاباد',
				name: 'مهاباد',
				coordinate: new Coordinates(36.7702217102051, 45.7284126281738)
			},
			{
				id: 'مياندوآب',
				name: 'مياندوآب',
				coordinate: new Coordinates(36.9649620056152, 46.1059494018555)
			},
			{
				id: 'ميرآباد',
				name: 'ميرآباد',
				coordinate: new Coordinates(36.4030838012695, 45.3748664855957)
			},
			{
				id: 'نالوس',
				name: 'نالوس',
				coordinate: new Coordinates(36.9845085144043, 45.1431427001953)
			},
			{
				id: 'نقده',
				name: 'نقده',
				coordinate: new Coordinates(36.9533843994141, 45.3889045715332)
			},
			{
				id: 'نوشين',
				name: 'نوشين',
				coordinate: new Coordinates(37.7343368530273, 45.0522918701172)
			}
		]
	},
	{
		name: 'بوشهر',
		cities: [
			{
				id: 'امام حسن',
				name: 'امام حسن',
				coordinate: new Coordinates(29.8396549224854, 50.2638854980469)
			},
			{
				id: 'انارستان',
				name: 'انارستان',
				coordinate: new Coordinates(28.0325489044189, 52.0664672851563)
			},
			{
				id: 'اهرم',
				name: 'اهرم',
				coordinate: new Coordinates(28.8842239379883, 51.278694152832)
			},
			{
				id: 'آبپخش',
				name: 'آبپخش',
				coordinate: new Coordinates(29.3537864685059, 51.0646209716797)
			},
			{
				id: 'آبدان',
				name: 'آبدان',
				coordinate: new Coordinates(28.0739288330078, 51.7706451416016)
			},
			{
				id: 'برازجان',
				name: 'برازجان',
				coordinate: new Coordinates(29.2707118988037, 51.2167091369629)
			},
			{
				id: 'بردخون',
				name: 'بردخون',
				coordinate: new Coordinates(28.0638523101807, 51.4778366088867)
			},
			{
				id: 'بردستان',
				name: 'بردستان',
				coordinate: new Coordinates(27.8714828491211, 51.959644317627)
			},
			{
				id: 'بندردير',
				name: 'بندردير',
				coordinate: new Coordinates(27.8390598297119, 51.9350128173828)
			},
			{
				id: 'بندرديلم',
				name: 'بندرديلم',
				coordinate: new Coordinates(30.052282333374, 50.1631889343262)
			},
			{
				id: 'بندرريگ',
				name: 'بندرريگ',
				coordinate: new Coordinates(29.4879055023193, 50.6264762878418)
			},
			{
				id: 'بندركنگان',
				name: 'بندركنگان',
				coordinate: new Coordinates(27.8377628326416, 52.0617942810059)
			},
			{
				id: 'بندرگناوه',
				name: 'بندرگناوه',
				coordinate: new Coordinates(29.5736541748047, 50.5185432434082)
			},
			{
				id: 'بنك',
				name: 'بنك',
				coordinate: new Coordinates(27.8716888427734, 52.0273971557617)
			},
			{
				id: 'بوشهر',
				name: 'بوشهر',
				coordinate: new Coordinates(28.9214267730713, 50.8376693725586)
			},
			{
				id: 'تنگ ارم',
				name: 'تنگ ارم',
				coordinate: new Coordinates(29.1536903381348, 51.5274200439453)
			},
			{
				id: 'جم',
				name: 'جم',
				coordinate: new Coordinates(27.8243522644043, 52.340950012207)
			},
			{
				id: 'چغادك',
				name: 'چغادك',
				coordinate: new Coordinates(28.9875717163086, 51.025016784668)
			},
			{
				id: 'خارك',
				name: 'خارك',
				coordinate: new Coordinates(29.2380523681641, 50.3193054199219)
			},
			{
				id: 'خورموج',
				name: 'خورموج',
				coordinate: new Coordinates(28.6271820068359, 51.3825225830078)
			},
			{
				id: 'دالكي',
				name: 'دالكي',
				coordinate: new Coordinates(29.4292411804199, 51.2911491394043)
			},
			{
				id: 'دلوار',
				name: 'دلوار',
				coordinate: new Coordinates(28.7459945678711, 51.070182800293)
			},
			{
				id: 'ريز',
				name: 'ريز',
				coordinate: new Coordinates(28.0555763244629, 52.0770797729492)
			},
			{
				id: 'سعدآباد',
				name: 'سعدآباد',
				coordinate: new Coordinates(29.3841953277588, 51.116641998291)
			},
			{
				id: 'سيراف',
				name: 'سيراف',
				coordinate: new Coordinates(27.6681728363037, 52.3388481140137)
			},
			{
				id: 'شبانكاره',
				name: 'شبانكاره',
				coordinate: new Coordinates(29.4725437164307, 50.9940643310547)
			},
			{
				id: 'شنبه',
				name: 'شنبه',
				coordinate: new Coordinates(28.3949813842773, 51.764030456543)
			},
			{
				id: 'عسلويه',
				name: 'عسلويه',
				coordinate: new Coordinates(27.4757614135742, 52.6081085205078)
			},
			{
				id: 'كاكي',
				name: 'كاكي',
				coordinate: new Coordinates(28.3402099609375, 51.5226783752441)
			},
			{
				id: 'كلمه',
				name: 'كلمه',
				coordinate: new Coordinates(28.9435176849365, 51.4593315124512)
			},
			{
				id: 'نخل تقي',
				name: 'نخل تقي',
				coordinate: new Coordinates(27.4970149993896, 52.5839881896973)
			},
			{
				id: 'وحدتيه',
				name: 'وحدتيه',
				coordinate: new Coordinates(29.4829578399658, 51.2363777160645)
			}
		]
	},
	{
		name: 'تهران',
		cities: [
			{
				id: 'ارجمند',
				name: 'ارجمند',
				coordinate: new Coordinates(35.8140182495117, 52.5138244628906)
			},
			{
				id: 'اسلامشهر',
				name: 'اسلامشهر',
				coordinate: new Coordinates(35.5010452270508, 51.2255477905273)
			},
			{
				id: 'انديشه',
				name: 'انديشه',
				coordinate: new Coordinates(35.6873931884766, 51.0223922729492)
			},
			{
				id: 'آبسرد',
				name: 'آبسرد',
				coordinate: new Coordinates(35.6217079162598, 52.1501274108887)
			},
			{
				id: 'آبعلي',
				name: 'آبعلي',
				coordinate: new Coordinates(35.7596244812012, 51.9629592895508)
			},
			{
				id: 'باغستان',
				name: 'باغستان',
				coordinate: new Coordinates(35.6345520019531, 51.1331520080566)
			},
			{
				id: 'باقرشهر',
				name: 'باقرشهر',
				coordinate: new Coordinates(35.5262451171875, 51.4030609130859)
			},
			{
				id: 'بومهن',
				name: 'بومهن',
				coordinate: new Coordinates(35.7278480529785, 51.8688316345215)
			},
			{
				id: 'پاكدشت',
				name: 'پاكدشت',
				coordinate: new Coordinates(35.4743118286133, 51.6757011413574)
			},
			{
				id: 'پرديس',
				name: 'پرديس',
				coordinate: new Coordinates(35.7423477172852, 51.8214073181152)
			},
			{
				id: 'پيشوا',
				name: 'پيشوا',
				coordinate: new Coordinates(35.3055534362793, 51.7224388122559)
			},
			{
				id: 'تجريش',
				name: 'تجريش',
				coordinate: new Coordinates(35.8103790283203, 51.4647598266602)
			},
			{
				id: 'تهران',
				name: 'تهران',
				coordinate: new Coordinates(35.7029075622559, 51.3497581481934)
			},
			{
				id: 'جوادآباد',
				name: 'جوادآباد',
				coordinate: new Coordinates(35.2108612060547, 51.6731834411621)
			},
			{
				id: 'چهاردانگه',
				name: 'چهاردانگه',
				coordinate: new Coordinates(35.5963745117187, 51.3045654296875)
			},
			{
				id: 'حسن آباد',
				name: 'حسن آباد',
				coordinate: new Coordinates(35.3676567077637, 51.2429885864258)
			},
			{
				id: 'دماوند',
				name: 'دماوند',
				coordinate: new Coordinates(35.6939544677734, 52.0472183227539)
			},
			{
				id: 'رباط كريم',
				name: 'رباط كريم',
				coordinate: new Coordinates(35.4832000732422, 51.0799140930176)
			},
			{
				id: 'رودهن',
				name: 'رودهن',
				coordinate: new Coordinates(35.7376098632812, 51.9104232788086)
			},
			{
				id: 'ري',
				name: 'ري',
				coordinate: new Coordinates(35.6031913757324, 51.4387092590332)
			},
			{
				id: 'شاهدشهر',
				name: 'شاهدشهر',
				coordinate: new Coordinates(35.5718612670898, 51.0873832702637)
			},
			{
				id: 'شريف آباد',
				name: 'شريف آباد',
				coordinate: new Coordinates(35.4223403930664, 51.7859191894531)
			},
			{
				id: 'شهريار',
				name: 'شهريار',
				coordinate: new Coordinates(35.6330146789551, 51.0597038269043)
			},
			{
				id: 'صالح آباد',
				name: 'صالح آباد',
				coordinate: new Coordinates(35.504940032959, 51.189136505127)
			},
			{
				id: 'صباشهر',
				name: 'صباشهر',
				coordinate: new Coordinates(35.5787582397461, 51.1142654418945)
			},
			{
				id: 'صفادشت',
				name: 'صفادشت',
				coordinate: new Coordinates(35.6913528442383, 50.8406944274902)
			},
			{
				id: 'فردوسيه',
				name: 'فردوسيه',
				coordinate: new Coordinates(35.6019287109375, 51.0632095336914)
			},
			{
				id: 'فرون آباد',
				name: 'فرون آباد',
				coordinate: new Coordinates(35.5052719116211, 51.627082824707)
			},
			{
				id: 'فشم',
				name: 'فشم',
				coordinate: new Coordinates(35.9017333984375, 51.5198364257813)
			},
			{
				id: 'فيروزكوه',
				name: 'فيروزكوه',
				coordinate: new Coordinates(35.7545585632324, 52.7738723754883)
			},
			{
				id: 'قدس',
				name: 'قدس',
				coordinate: new Coordinates(35.7124824523926, 51.1128921508789)
			},
			{
				id: 'قرچك',
				name: 'قرچك',
				coordinate: new Coordinates(35.4157943725586, 51.5866737365723)
			},
			{
				id: 'كهريزك',
				name: 'كهريزك',
				coordinate: new Coordinates(35.5238151550293, 51.3551025390625)
			},
			{
				id: 'كيلان',
				name: 'كيلان',
				coordinate: new Coordinates(35.5561485290527, 52.1628723144531)
			},
			{
				id: 'گلستان',
				name: 'گلستان',
				coordinate: new Coordinates(35.5160102844238, 51.1621894836426)
			},
			{
				id: 'لواسان',
				name: 'لواسان',
				coordinate: new Coordinates(35.8194007873535, 51.6372909545899)
			},
			{
				id: 'ملارد',
				name: 'ملارد',
				coordinate: new Coordinates(35.6547012329102, 50.979175567627)
			},
			{
				id: 'نسيم شهر',
				name: 'نسيم شهر',
				coordinate: new Coordinates(35.5586891174316, 51.169490814209)
			},
			{
				id: 'نصيرآباد',
				name: 'نصيرآباد',
				coordinate: new Coordinates(35.4901885986328, 51.1410446166992)
			},
			{
				id: 'وحيديه',
				name: 'وحيديه',
				coordinate: new Coordinates(35.6052207946777, 51.0261039733887)
			},
			{
				id: 'ورامين',
				name: 'ورامين',
				coordinate: new Coordinates(35.3293952941895, 51.6346855163574)
			}
		]
	},
	{
		name: 'چهارمحال وبختياري',
		cities: [
			{
				id: 'اردل',
				name: 'اردل',
				coordinate: new Coordinates(31.9978656768799, 50.6614532470703)
			},
			{
				id: 'آلوني',
				name: 'آلوني',
				coordinate: new Coordinates(31.5522041320801, 51.057014465332)
			},
			{
				id: 'باباحيدر',
				name: 'باباحيدر',
				coordinate: new Coordinates(32.3289451599121, 50.4688758850098)
			},
			{
				id: 'بروجن',
				name: 'بروجن',
				coordinate: new Coordinates(31.9667949676514, 51.2894248962402)
			},
			{
				id: 'بلداجي',
				name: 'بلداجي',
				coordinate: new Coordinates(31.9370422363281, 51.0526123046875)
			},
			{
				id: 'بن',
				name: 'بن',
				coordinate: new Coordinates(32.542781829834, 50.746208190918)
			},
			{
				id: 'جونقان',
				name: 'جونقان',
				coordinate: new Coordinates(32.1429557800293, 50.6865997314453)
			},
			{
				id: 'چلگرد',
				name: 'چلگرد',
				coordinate: new Coordinates(32.4672775268555, 50.1300430297852)
			},
			{
				id: 'سامان',
				name: 'سامان',
				coordinate: new Coordinates(32.4515762329102, 50.910457611084)
			},
			{
				id: 'سفيددشت',
				name: 'سفيددشت',
				coordinate: new Coordinates(32.1297721862793, 51.1828765869141)
			},
			{
				id: 'سودجان',
				name: 'سودجان',
				coordinate: new Coordinates(32.521125793457, 50.4003562927246)
			},
			{
				id: 'سورشجان',
				name: 'سورشجان',
				coordinate: new Coordinates(32.3158149719238, 50.6788520812988)
			},
			{
				id: 'شلمزار',
				name: 'شلمزار',
				coordinate: new Coordinates(32.0466194152832, 50.8170471191406)
			},
			{
				id: 'شهركرد',
				name: 'شهركرد',
				coordinate: new Coordinates(32.3161811828613, 50.8582038879395)
			},
			{
				id: 'طاقانك',
				name: 'طاقانك',
				coordinate: new Coordinates(32.2231254577637, 50.8369407653809)
			},
			{
				id: 'فارسان',
				name: 'فارسان',
				coordinate: new Coordinates(32.2572975158691, 50.5656776428223)
			},
			{
				id: 'فرادنبه',
				name: 'فرادنبه',
				coordinate: new Coordinates(32.0085716247559, 51.2147483825684)
			},
			{
				id: 'فرخ شهر',
				name: 'فرخ شهر',
				coordinate: new Coordinates(32.273983001709, 50.9729461669922)
			},
			{
				id: 'كيان',
				name: 'كيان',
				coordinate: new Coordinates(32.2833137512207, 50.8891754150391)
			},
			{
				id: 'گندمان',
				name: 'گندمان',
				coordinate: new Coordinates(31.8630504608154, 51.1533851623535)
			},
			{
				id: 'گهرو',
				name: 'گهرو',
				coordinate: new Coordinates(32.0015258789063, 50.886287689209)
			},
			{
				id: 'لردگان',
				name: 'لردگان',
				coordinate: new Coordinates(31.5108184814453, 50.8300895690918)
			},
			{
				id: 'مال خليفه',
				name: 'مال خليفه',
				coordinate: new Coordinates(31.2898597717285, 51.2654075622559)
			},
			{
				id: 'ناغان',
				name: 'ناغان',
				coordinate: new Coordinates(31.9343223571777, 50.7306022644043)
			},
			{
				id: 'نافچ',
				name: 'نافچ',
				coordinate: new Coordinates(32.4240951538086, 50.7884368896484)
			},
			{
				id: 'نقنه',
				name: 'نقنه',
				coordinate: new Coordinates(31.932336807251, 51.3288421630859)
			},
			{
				id: 'هفشجان',
				name: 'هفشجان',
				coordinate: new Coordinates(32.2255935668945, 50.7946319580078)
			}
		]
	},
	{
		name: 'خراسان جنوبي',
		cities: [
			{
				id: 'ارسك',
				name: 'ارسك',
				coordinate: new Coordinates(33.7036666870117, 57.3718185424805)
			},
			{
				id: 'اسديه',
				name: 'اسديه',
				coordinate: new Coordinates(32.9159278869629, 60.0244903564453)
			},
			{
				id: 'اسفدن',
				name: 'اسفدن',
				coordinate: new Coordinates(33.6452674865723, 59.7787857055664)
			},
			{
				id: 'اسلاميه',
				name: 'اسلاميه',
				coordinate: new Coordinates(34.0423126220703, 58.2200088500977)
			},
			{
				id: 'آرين شهر',
				name: 'آرين شهر',
				coordinate: new Coordinates(33.3311004638672, 59.2329978942871)
			},
			{
				id: 'آيسك',
				name: 'آيسك',
				coordinate: new Coordinates(33.8866500854492, 58.3815956115723)
			},
			{
				id: 'بشرويه',
				name: 'بشرويه',
				coordinate: new Coordinates(33.8528137207031, 57.4224433898926)
			},
			{
				id: 'بيرجند',
				name: 'بيرجند',
				coordinate: new Coordinates(32.85693359375, 59.2195472717285)
			},
			{
				id: 'حاجي آباد',
				name: 'حاجي آباد',
				coordinate: new Coordinates(33.6046752929687, 59.9975357055664)
			},
			{
				id: 'خضري دشت بياض',
				name: 'خضري دشت بياض',
				coordinate: new Coordinates(34.02294921875, 58.8065414428711)
			},
			{
				id: 'خوسف',
				name: 'خوسف',
				coordinate: new Coordinates(32.7791709899902, 58.8858642578125)
			},
			{
				id: 'زهان',
				name: 'زهان',
				coordinate: new Coordinates(33.4197387695312, 59.8108901977539)
			},
			{
				id: 'سرايان',
				name: 'سرايان',
				coordinate: new Coordinates(33.8603744506836, 58.5223197937012)
			},
			{
				id: 'سربيشه',
				name: 'سربيشه',
				coordinate: new Coordinates(32.576358795166, 59.7983474731445)
			},
			{
				id: 'سه قلعه',
				name: 'سه قلعه',
				coordinate: new Coordinates(33.6664695739746, 58.3994026184082)
			},
			{
				id: 'شوسف',
				name: 'شوسف',
				coordinate: new Coordinates(31.803337097168, 60.0088691711426)
			},
			{
				id: 'طبس مسينا',
				name: 'طبس مسينا',
				coordinate: new Coordinates(32.801082611084, 60.2229385375977)
			},
			{
				id: 'فردوس',
				name: 'فردوس',
				coordinate: new Coordinates(34.0180778503418, 58.1723861694336)
			},
			{
				id: 'قائن',
				name: 'قائن',
				coordinate: new Coordinates(33.7294464111328, 59.1809043884277)
			},
			{
				id: 'قهستان',
				name: 'قهستان',
				coordinate: new Coordinates(33.1463317871094, 59.7157897949219)
			},
			{
				id: 'گزيك',
				name: 'گزيك',
				coordinate: new Coordinates(33.000301361084, 60.2225608825684)
			},
			{
				id: 'محمدشهر',
				name: 'محمدشهر',
				coordinate: new Coordinates(32.8749847412109, 59.0177345275879)
			},
			{
				id: 'مود',
				name: 'مود',
				coordinate: new Coordinates(32.7053298950195, 59.5241508483887)
			},
			{
				id: 'نهبندان',
				name: 'نهبندان',
				coordinate: new Coordinates(31.5407867431641, 60.0378074645996)
			},
			{
				id: 'نيمبلوك',
				name: 'نيمبلوك',
				coordinate: new Coordinates(33.9011001586914, 58.9294319152832)
			}
		]
	},
	{
		name: 'خراسان رضوي',
		cities: [
			{
				id: 'احمدآبادصولت',
				name: 'احمدآبادصولت',
				coordinate: new Coordinates(35.1155395507813, 60.689380645752)
			},
			{
				id: 'انابد',
				name: 'انابد',
				coordinate: new Coordinates(35.2511215209961, 57.8098602294922)
			},
			{
				id: 'باجگيران',
				name: 'باجگيران',
				coordinate: new Coordinates(37.6241149902344, 58.4152908325195)
			},
			{
				id: 'باخرز',
				name: 'باخرز',
				coordinate: new Coordinates(34.9832916259766, 60.3187561035156)
			},
			{
				id: 'بار',
				name: 'بار',
				coordinate: new Coordinates(36.4888763427734, 58.7191543579102)
			},
			{
				id: 'بايگ',
				name: 'بايگ',
				coordinate: new Coordinates(35.3751373291016, 59.0397071838379)
			},
			{
				id: 'بجستان',
				name: 'بجستان',
				coordinate: new Coordinates(34.5154876708984, 58.1818618774414)
			},
			{
				id: 'بردسكن',
				name: 'بردسكن',
				coordinate: new Coordinates(35.2602806091309, 57.9720497131348)
			},
			{
				id: 'بيدخت',
				name: 'بيدخت',
				coordinate: new Coordinates(34.3462905883789, 58.7573356628418)
			},
			{
				id: 'تايباد',
				name: 'تايباد',
				coordinate: new Coordinates(34.7398376464844, 60.7771377563477)
			},
			{
				id: 'تربت جام',
				name: 'تربت جام',
				coordinate: new Coordinates(35.2416458129883, 60.6216163635254)
			},
			{
				id: 'تربت حيدريه',
				name: 'تربت حيدريه',
				coordinate: new Coordinates(35.2784576416016, 59.213020324707)
			},
			{
				id: 'جغتاي',
				name: 'جغتاي',
				coordinate: new Coordinates(36.6396522521973, 57.077205657959)
			},
			{
				id: 'جنگل',
				name: 'جنگل',
				coordinate: new Coordinates(34.7016372680664, 59.2234687805176)
			},
			{
				id: 'چاپشلو',
				name: 'چاپشلو',
				coordinate: new Coordinates(37.3474235534668, 59.0771827697754)
			},
			{
				id: 'چكنه',
				name: 'چكنه',
				coordinate: new Coordinates(36.8179702758789, 58.5041961669922)
			},
			{
				id: 'چناران',
				name: 'چناران',
				coordinate: new Coordinates(36.6422805786133, 59.1208381652832)
			},
			{
				id: 'خرو',
				name: 'خرو',
				coordinate: new Coordinates(36.1364898681641, 59.0270690917969)
			},
			{
				id: 'خليل آباد',
				name: 'خليل آباد',
				coordinate: new Coordinates(35.244987487793, 58.2851638793945)
			},
			{
				id: 'خواف',
				name: 'خواف',
				coordinate: new Coordinates(34.5628662109375, 60.1442947387695)
			},
			{
				id: 'داورزن',
				name: 'داورزن',
				coordinate: new Coordinates(36.3512573242187, 56.8780403137207)
			},
			{
				id: 'درگز',
				name: 'درگز',
				coordinate: new Coordinates(37.444751739502, 59.105712890625)
			},
			{
				id: 'درود',
				name: 'درود',
				coordinate: new Coordinates(36.1357383728027, 59.1123695373535)
			},
			{
				id: 'دولت آباد',
				name: 'دولت آباد',
				coordinate: new Coordinates(35.2820816040039, 59.5221214294434)
			},
			{
				id: 'رباط سنگ',
				name: 'رباط سنگ',
				coordinate: new Coordinates(35.5446968078613, 59.1941795349121)
			},
			{
				id: 'رشتخوار',
				name: 'رشتخوار',
				coordinate: new Coordinates(34.9750671386719, 59.623046875)
			},
			{
				id: 'رضويه',
				name: 'رضويه',
				coordinate: new Coordinates(36.2055015563965, 59.7698516845703)
			},
			{
				id: 'روداب',
				name: 'روداب',
				coordinate: new Coordinates(36.0208129882812, 57.3124046325684)
			},
			{
				id: 'ريوش',
				name: 'ريوش',
				coordinate: new Coordinates(35.4765243530273, 58.4616928100586)
			},
			{
				id: 'سبزوار',
				name: 'سبزوار',
				coordinate: new Coordinates(36.2092132568359, 57.6823196411133)
			},
			{
				id: 'سرخس',
				name: 'سرخس',
				coordinate: new Coordinates(36.548656463623, 61.1486015319824)
			},
			{
				id: 'سفيدسنگ',
				name: 'سفيدسنگ',
				coordinate: new Coordinates(35.6600952148437, 60.0933303833008)
			},
			{
				id: 'سلامي',
				name: 'سلامي',
				coordinate: new Coordinates(34.7443695068359, 59.9764709472656)
			},
			{
				id: 'سلطان آباد',
				name: 'سلطان آباد',
				coordinate: new Coordinates(36.4027976989746, 58.0398902893066)
			},
			{
				id: 'سنگان',
				name: 'سنگان',
				coordinate: new Coordinates(34.3977737426758, 60.2554779052734)
			},
			{
				id: 'شادمهر',
				name: 'شادمهر',
				coordinate: new Coordinates(35.1734199523926, 59.0379638671875)
			},
			{
				id: 'شانديز',
				name: 'شانديز',
				coordinate: new Coordinates(36.3952140808105, 59.2981948852539)
			},
			{
				id: 'ششتمد',
				name: 'ششتمد',
				coordinate: new Coordinates(35.9595794677734, 57.7702255249023)
			},
			{
				id: 'شهرآباد',
				name: 'شهرآباد',
				coordinate: new Coordinates(35.1469116210937, 57.934871673584)
			},
			{
				id: 'شهرزو',
				name: 'شهرزو',
				coordinate: new Coordinates(36.746036529541, 59.9242820739746)
			},
			{
				id: 'صالح آباد',
				name: 'صالح آباد',
				coordinate: new Coordinates(35.6879920959473, 61.0904541015625)
			},
			{
				id: 'طرقبه',
				name: 'طرقبه',
				coordinate: new Coordinates(36.3042984008789, 59.3763275146484)
			},
			{
				id: 'عشق آباد',
				name: 'عشق آباد',
				coordinate: new Coordinates(36.0394172668457, 58.6832084655762)
			},
			{
				id: 'فرهادگرد',
				name: 'فرهادگرد',
				coordinate: new Coordinates(35.7518272399902, 59.7298851013184)
			},
			{
				id: 'فريمان',
				name: 'فريمان',
				coordinate: new Coordinates(35.7040328979492, 59.8482780456543)
			},
			{
				id: 'فيروزه',
				name: 'فيروزه',
				coordinate: new Coordinates(36.2856063842773, 58.5890197753906)
			},
			{
				id: 'فيض آباد',
				name: 'فيض آباد',
				coordinate: new Coordinates(35.0146217346191, 58.7751235961914)
			},
			{
				id: 'قاسم آباد',
				name: 'قاسم آباد',
				coordinate: new Coordinates(34.3556022644043, 59.8619689941406)
			},
			{
				id: 'قدمگاه',
				name: 'قدمگاه',
				coordinate: new Coordinates(36.1058921813965, 59.0604667663574)
			},
			{
				id: 'قلندرآباد',
				name: 'قلندرآباد',
				coordinate: new Coordinates(35.5989685058594, 59.951042175293)
			},
			{
				id: 'قوچان',
				name: 'قوچان',
				coordinate: new Coordinates(37.102367401123, 58.510871887207)
			},
			{
				id: 'كاخك',
				name: 'كاخك',
				coordinate: new Coordinates(34.1486740112305, 58.6445121765137)
			},
			{
				id: 'كاريز',
				name: 'كاريز',
				coordinate: new Coordinates(34.8136367797852, 60.825382232666)
			},
			{
				id: 'كاشمر',
				name: 'كاشمر',
				coordinate: new Coordinates(35.2427597045898, 58.4598808288574)
			},
			{
				id: 'كدكن',
				name: 'كدكن',
				coordinate: new Coordinates(35.5858345031738, 58.8789710998535)
			},
			{
				id: 'كلات',
				name: 'كلات',
				coordinate: new Coordinates(36.9945602416992, 59.7498817443848)
			},
			{
				id: 'كندر',
				name: 'كندر',
				coordinate: new Coordinates(35.212459564209, 58.1507797241211)
			},
			{
				id: 'گلمكان',
				name: 'گلمكان',
				coordinate: new Coordinates(36.482105255127, 59.1594924926758)
			},
			{
				id: 'گناباد',
				name: 'گناباد',
				coordinate: new Coordinates(34.351749420166, 58.6857109069824)
			},
			{
				id: 'لطف آباد',
				name: 'لطف آباد',
				coordinate: new Coordinates(37.5152320861816, 59.3347320556641)
			},
			{
				id: 'مزدآوند',
				name: 'مزدآوند',
				coordinate: new Coordinates(36.1546516418457, 60.5276298522949)
			},
			{
				id: 'مشهد',
				name: 'مشهد',
				coordinate: new Coordinates(36.310432434082, 59.5756721496582)
			},
			{
				id: 'مشهدريزه',
				name: 'مشهدريزه',
				coordinate: new Coordinates(34.7951889038086, 60.5076179504395)
			},
			{
				id: 'ملك آباد',
				name: 'ملك آباد',
				coordinate: new Coordinates(35.9965972900391, 59.5935859680176)
			},
			{
				id: 'نشتيفان',
				name: 'نشتيفان',
				coordinate: new Coordinates(34.4343605041504, 60.1764221191406)
			},
			{
				id: 'نصرآباد',
				name: 'نصرآباد',
				coordinate: new Coordinates(35.4180755615234, 60.3153991699219)
			},
			{
				id: 'نقاب',
				name: 'نقاب',
				coordinate: new Coordinates(36.7085456848145, 57.4081573486328)
			},
			{
				id: 'نوخندان',
				name: 'نوخندان',
				coordinate: new Coordinates(37.5193481445312, 58.9889144897461)
			},
			{
				id: 'نيشابور',
				name: 'نيشابور',
				coordinate: new Coordinates(36.2079277038574, 58.7940292358398)
			},
			{
				id: 'نيل شهر',
				name: 'نيل شهر',
				coordinate: new Coordinates(35.1228561401367, 60.7731323242188)
			},
			{
				id: 'همت آباد',
				name: 'همت آباد',
				coordinate: new Coordinates(36.2977828979492, 58.4641571044922)
			},
			{
				id: 'يونسي',
				name: 'يونسي',
				coordinate: new Coordinates(34.8053817749023, 58.4372138977051)
			}
		]
	},
	{
		name: 'خراسان شمالي',
		cities: [
			{
				id: 'اسفراين',
				name: 'اسفراين',
				coordinate: new Coordinates(37.0726661682129, 57.5096626281738)
			},
			{
				id: 'ايور',
				name: 'ايور',
				coordinate: new Coordinates(36.9688110351562, 56.2607841491699)
			},
			{
				id: 'آشخانه',
				name: 'آشخانه',
				coordinate: new Coordinates(37.558177947998, 56.9239616394043)
			},
			{
				id: 'بجنورد',
				name: 'بجنورد',
				coordinate: new Coordinates(37.4467887878418, 57.3274574279785)
			},
			{
				id: 'پيش قلعه',
				name: 'پيش قلعه',
				coordinate: new Coordinates(37.6486015319824, 57.0014762878418)
			},
			{
				id: 'تيتكانلو',
				name: 'تيتكانلو',
				coordinate: new Coordinates(37.2805557250977, 58.2895126342774)
			},
			{
				id: 'جاجرم',
				name: 'جاجرم',
				coordinate: new Coordinates(36.9556427001953, 56.3577766418457)
			},
			{
				id: 'حصارگرمخان',
				name: 'حصارگرمخان',
				coordinate: new Coordinates(37.5158538818359, 57.4848861694336)
			},
			{
				id: 'درق',
				name: 'درق',
				coordinate: new Coordinates(36.9720687866211, 56.2145004272461)
			},
			{
				id: 'راز',
				name: 'راز',
				coordinate: new Coordinates(37.934455871582, 57.1075477600098)
			},
			{
				id: 'سنخواست',
				name: 'سنخواست',
				coordinate: new Coordinates(37.0999031066895, 56.8515586853027)
			},
			{
				id: 'شوقان',
				name: 'شوقان',
				coordinate: new Coordinates(37.3416366577148, 56.8870811462402)
			},
			{
				id: 'شيروان',
				name: 'شيروان',
				coordinate: new Coordinates(37.4015159606934, 57.9241676330566)
			},
			{
				id: 'صفي آباد',
				name: 'صفي آباد',
				coordinate: new Coordinates(36.6955032348633, 57.9270248413086)
			},
			{
				id: 'فاروج',
				name: 'فاروج',
				coordinate: new Coordinates(37.2236938476563, 58.2189064025879)
			},
			{
				id: 'قاضي',
				name: 'قاضي',
				coordinate: new Coordinates(37.4950065612793, 56.7486572265625)
			},
			{
				id: 'گرمه',
				name: 'گرمه',
				coordinate: new Coordinates(36.9785194396973, 56.3015403747559)
			},
			{
				id: 'لوجلي',
				name: 'لوجلي',
				coordinate: new Coordinates(37.6070404052734, 57.8576354980469)
			}
		]
	},
	{
		name: 'خوزستان',
		cities: [
			{
				id: 'اروندكنار',
				name: 'اروندكنار',
				coordinate: new Coordinates(29.9780826568603, 48.5168266296387)
			},
			{
				id: 'الوان',
				name: 'الوان',
				coordinate: new Coordinates(31.8741016387939, 48.3411140441895)
			},
			{
				id: 'اميديه',
				name: 'اميديه',
				coordinate: new Coordinates(30.7556076049805, 49.7122497558594)
			},
			{
				id: 'انديمشك',
				name: 'انديمشك',
				coordinate: new Coordinates(32.4246444702148, 48.3731002807617)
			},
			{
				id: 'اهواز',
				name: 'اهواز',
				coordinate: new Coordinates(31.2420139312744, 48.671272277832)
			},
			{
				id: 'ايذه',
				name: 'ايذه',
				coordinate: new Coordinates(31.8306846618652, 49.8649368286133)
			},
			{
				id: 'آبادان',
				name: 'آبادان',
				coordinate: new Coordinates(30.3560085296631, 48.2800521850586)
			},
			{
				id: 'آغاجاري',
				name: 'آغاجاري',
				coordinate: new Coordinates(30.6997203826904, 49.8297691345215)
			},
			{
				id: 'باغ ملك',
				name: 'باغ ملك',
				coordinate: new Coordinates(31.5133056640625, 49.890495300293)
			},
			{
				id: 'بستان',
				name: 'بستان',
				coordinate: new Coordinates(31.7216396331787, 47.9811477661133)
			},
			{
				id: 'بندرامام خميني',
				name: 'بندرامام خميني',
				coordinate: new Coordinates(30.43869972229, 49.0756721496582)
			},
			{
				id: 'بندرماهشهر',
				name: 'بندرماهشهر',
				coordinate: new Coordinates(30.4694690704346, 49.1800079345703)
			},
			{
				id: 'بهبهان',
				name: 'بهبهان',
				coordinate: new Coordinates(30.596263885498, 50.2416076660156)
			},
			{
				id: 'تركالكي',
				name: 'تركالكي',
				coordinate: new Coordinates(32.24267578125, 48.846321105957)
			},
			{
				id: 'جايزان',
				name: 'جايزان',
				coordinate: new Coordinates(30.8749504089355, 49.854434967041)
			},
			{
				id: 'جنت مكان',
				name: 'جنت مكان',
				coordinate: new Coordinates(32.1843070983887, 48.8161468505859)
			},
			{
				id: 'چغاميش',
				name: 'چغاميش',
				coordinate: new Coordinates(32.2094802856445, 48.5455551147461)
			},
			{
				id: 'چمران',
				name: 'چمران',
				coordinate: new Coordinates(30.7135639190674, 49.1768684387207)
			},
			{
				id: 'چوئبده',
				name: 'چوئبده',
				coordinate: new Coordinates(30.2000465393066, 48.5531883239746)
			},
			{
				id: 'حر',
				name: 'حر',
				coordinate: new Coordinates(32.1442184448242, 48.3905258178711)
			},
			{
				id: 'حسينيه',
				name: 'حسينيه',
				coordinate: new Coordinates(32.6633529663086, 48.2456207275391)
			},
			{
				id: 'حمزه',
				name: 'حمزه',
				coordinate: new Coordinates(32.3962249755859, 48.578540802002)
			},
			{
				id: 'حميديه',
				name: 'حميديه',
				coordinate: new Coordinates(31.4816207885742, 48.4323997497559)
			},
			{
				id: 'خرمشهر',
				name: 'خرمشهر',
				coordinate: new Coordinates(30.4448184967041, 48.1787910461426)
			},
			{
				id: 'دارخوين',
				name: 'دارخوين',
				coordinate: new Coordinates(30.7449321746826, 48.4292488098145)
			},
			{
				id: 'دزآب',
				name: 'دزآب',
				coordinate: new Coordinates(32.2879066467285, 48.4282379150391)
			},
			{
				id: 'دزفول',
				name: 'دزفول',
				coordinate: new Coordinates(32.3788948059082, 48.4193000793457)
			},
			{
				id: 'دهدز',
				name: 'دهدز',
				coordinate: new Coordinates(31.7099552154541, 50.2885284423828)
			},
			{
				id: 'رامشير',
				name: 'رامشير',
				coordinate: new Coordinates(30.8927555084229, 49.4088287353516)
			},
			{
				id: 'رامهرمز',
				name: 'رامهرمز',
				coordinate: new Coordinates(31.2592163085937, 49.6053123474121)
			},
			{
				id: 'رفيع',
				name: 'رفيع',
				coordinate: new Coordinates(31.5974349975586, 47.894172668457)
			},
			{
				id: 'زهره',
				name: 'زهره',
				coordinate: new Coordinates(30.4681549072266, 49.6830101013184)
			},
			{
				id: 'سالند',
				name: 'سالند',
				coordinate: new Coordinates(32.494068145752, 48.8343353271484)
			},
			{
				id: 'سردشت',
				name: 'سردشت',
				coordinate: new Coordinates(30.3278064727783, 50.2178802490234)
			},
			{
				id: 'سماله',
				name: 'سماله',
				coordinate: new Coordinates(32.1940116882324, 48.8577537536621)
			},
			{
				id: 'سوسنگرد',
				name: 'سوسنگرد',
				coordinate: new Coordinates(31.558614730835, 48.1895866394043)
			},
			{
				id: 'شادگان',
				name: 'شادگان',
				coordinate: new Coordinates(30.6412620544434, 48.6635360717773)
			},
			{
				id: 'شاوور',
				name: 'شاوور',
				coordinate: new Coordinates(32.0586853027344, 48.3008728027344)
			},
			{
				id: 'شرافت',
				name: 'شرافت',
				coordinate: new Coordinates(32.0880813598633, 48.7677192687988)
			},
			{
				id: 'شوش',
				name: 'شوش',
				coordinate: new Coordinates(32.2067451477051, 48.2574272155762)
			},
			{
				id: 'شوشتر',
				name: 'شوشتر',
				coordinate: new Coordinates(32.0546417236328, 48.834716796875)
			},
			{
				id: 'شيبان',
				name: 'شيبان',
				coordinate: new Coordinates(31.3845748901367, 48.7871131896973)
			},
			{
				id: 'صالح شهر',
				name: 'صالح شهر',
				coordinate: new Coordinates(32.2136726379395, 48.6721839904785)
			},
			{
				id: 'صالح مشطط',
				name: 'صالح مشطط',
				coordinate: new Coordinates(32.3135795593262, 48.1480674743652)
			},
			{
				id: 'صفي آباد',
				name: 'صفي آباد',
				coordinate: new Coordinates(32.2478446960449, 48.4215087890625)
			},
			{
				id: 'صيدون',
				name: 'صيدون',
				coordinate: new Coordinates(31.365743637085, 50.0813941955566)
			},
			{
				id: 'قلعه تل',
				name: 'قلعه تل',
				coordinate: new Coordinates(31.631498336792, 49.8901786804199)
			},
			{
				id: 'قلعه خواجه',
				name: 'قلعه خواجه',
				coordinate: new Coordinates(32.2052993774414, 49.4487037658691)
			},
			{
				id: 'گتوند',
				name: 'گتوند',
				coordinate: new Coordinates(32.2472152709961, 48.8178253173828)
			},
			{
				id: 'گوريه',
				name: 'گوريه',
				coordinate: new Coordinates(31.8566417694092, 48.7557907104492)
			},
			{
				id: 'لالي',
				name: 'لالي',
				coordinate: new Coordinates(32.3298187255859, 49.0929832458496)
			},
			{
				id: 'مسجدسليمان',
				name: 'مسجدسليمان',
				coordinate: new Coordinates(31.9646625518799, 49.2863388061523)
			},
			{
				id: 'مشراگه',
				name: 'مشراگه',
				coordinate: new Coordinates(31.0107021331787, 49.4379386901855)
			},
			{
				id: 'مقاومت',
				name: 'مقاومت',
				coordinate: new Coordinates(30.4068908691406, 48.1953277587891)
			},
			{
				id: 'ملاثاني',
				name: 'ملاثاني',
				coordinate: new Coordinates(31.5853481292725, 48.8870124816895)
			},
			{
				id: 'ميانرود',
				name: 'ميانرود',
				coordinate: new Coordinates(32.2278671264648, 48.4244613647461)
			},
			{
				id: 'ميداود',
				name: 'ميداود',
				coordinate: new Coordinates(31.3724670410156, 49.813663482666)
			},
			{
				id: 'مينوشهر',
				name: 'مينوشهر',
				coordinate: new Coordinates(30.3606548309326, 48.2103958129883)
			},
			{
				id: 'ويس',
				name: 'ويس',
				coordinate: new Coordinates(31.4841442108154, 48.8745079040527)
			},
			{
				id: 'هفتگل',
				name: 'هفتگل',
				coordinate: new Coordinates(31.4456787109375, 49.5331382751465)
			},
			{
				id: 'هنديجان',
				name: 'هنديجان',
				coordinate: new Coordinates(30.2236862182617, 49.7113990783691)
			},
			{
				id: 'هويزه',
				name: 'هويزه',
				coordinate: new Coordinates(31.4606819152832, 48.0774879455566)
			}
		]
	},
	{
		name: 'زنجان',
		cities: [
			{
				id: 'ابهر',
				name: 'ابهر',
				coordinate: new Coordinates(36.1361312866211, 49.2245445251465)
			},
			{
				id: 'ارمغانخانه',
				name: 'ارمغانخانه',
				coordinate: new Coordinates(36.9781494140625, 48.371940612793)
			},
			{
				id: 'آب بر',
				name: 'آب بر',
				coordinate: new Coordinates(36.9278526306152, 48.9561653137207)
			},
			{
				id: 'چورزق',
				name: 'چورزق',
				coordinate: new Coordinates(36.9928779602051, 48.7785263061523)
			},
			{
				id: 'حلب',
				name: 'حلب',
				coordinate: new Coordinates(36.2962112426758, 48.0638618469238)
			},
			{
				id: 'خرمدره',
				name: 'خرمدره',
				coordinate: new Coordinates(36.2114562988281, 49.1953887939453)
			},
			{
				id: 'دندي',
				name: 'دندي',
				coordinate: new Coordinates(36.5510940551758, 47.6202430725098)
			},
			{
				id: 'زرين آباد',
				name: 'زرين آباد',
				coordinate: new Coordinates(36.4292335510254, 48.2769508361816)
			},
			{
				id: 'زرين رود',
				name: 'زرين رود',
				coordinate: new Coordinates(35.756217956543, 48.4810905456543)
			},
			{
				id: 'زنجان',
				name: 'زنجان',
				coordinate: new Coordinates(36.6795539855957, 48.4929962158203)
			},
			{
				id: 'سجاس',
				name: 'سجاس',
				coordinate: new Coordinates(36.2405891418457, 48.5530853271484)
			},
			{
				id: 'سلطانيه',
				name: 'سلطانيه',
				coordinate: new Coordinates(36.4336318969727, 48.7955055236816)
			},
			{
				id: 'سهرورد',
				name: 'سهرورد',
				coordinate: new Coordinates(36.0728073120117, 48.4391021728516)
			},
			{
				id: 'صائين قلعه',
				name: 'صائين قلعه',
				coordinate: new Coordinates(36.3047676086426, 49.0723533630371)
			},
			{
				id: 'قيدار',
				name: 'قيدار',
				coordinate: new Coordinates(36.1085662841797, 48.5899887084961)
			},
			{
				id: 'گرماب',
				name: 'گرماب',
				coordinate: new Coordinates(35.8455390930176, 48.2011222839356)
			},
			{
				id: 'ماه نشان',
				name: 'ماه نشان',
				coordinate: new Coordinates(36.7435836791992, 47.6706466674805)
			},
			{
				id: 'هيدج',
				name: 'هيدج',
				coordinate: new Coordinates(36.2540397644043, 49.1295852661133)
			}
		]
	},
	{
		name: 'سمنان',
		cities: [
			{
				id: 'اميريه',
				name: 'اميريه',
				coordinate: new Coordinates(36.0280494689941, 54.142204284668)
			},
			{
				id: 'ايوانكي',
				name: 'ايوانكي',
				coordinate: new Coordinates(35.3449745178223, 52.068977355957)
			},
			{
				id: 'آرادان',
				name: 'آرادان',
				coordinate: new Coordinates(35.2516479492188, 52.4975395202637)
			},
			{
				id: 'بسطام',
				name: 'بسطام',
				coordinate: new Coordinates(36.4844627380371, 55.0009002685547)
			},
			{
				id: 'بيارجمند',
				name: 'بيارجمند',
				coordinate: new Coordinates(36.0786666870117, 55.807430267334)
			},
			{
				id: 'دامغان',
				name: 'دامغان',
				coordinate: new Coordinates(36.1651992797852, 54.344841003418)
			},
			{
				id: 'درجزين',
				name: 'درجزين',
				coordinate: new Coordinates(35.6456069946289, 53.3336410522461)
			},
			{
				id: 'ديباج',
				name: 'ديباج',
				coordinate: new Coordinates(36.4305229187012, 54.2289123535156)
			},
			{
				id: 'سرخه',
				name: 'سرخه',
				coordinate: new Coordinates(35.4637260437012, 53.2103576660156)
			},
			{
				id: 'سمنان',
				name: 'سمنان',
				coordinate: new Coordinates(35.5771141052246, 53.3819274902344)
			},
			{
				id: 'شاهرود',
				name: 'شاهرود',
				coordinate: new Coordinates(36.4120864868164, 54.9724617004395)
			},
			{
				id: 'شهميرزاد',
				name: 'شهميرزاد',
				coordinate: new Coordinates(35.7702331542969, 53.3335838317871)
			},
			{
				id: 'كلاته خيج',
				name: 'كلاته خيج',
				coordinate: new Coordinates(36.6705627441406, 55.3004875183106)
			},
			{
				id: 'گرمسار',
				name: 'گرمسار',
				coordinate: new Coordinates(35.2178230285645, 52.333625793457)
			},
			{
				id: 'مجن',
				name: 'مجن',
				coordinate: new Coordinates(36.4802207946777, 54.6479797363281)
			},
			{
				id: 'مهدي شهر',
				name: 'مهدي شهر',
				coordinate: new Coordinates(35.699649810791, 53.3458709716797)
			},
			{
				id: 'ميامي',
				name: 'ميامي',
				coordinate: new Coordinates(36.4093246459961, 55.6516532897949)
			}
		]
	},
	{
		name: 'سيستان وبلوچستان',
		cities: [
			{
				id: 'اديمي',
				name: 'اديمي',
				coordinate: new Coordinates(31.11745262146, 61.407642364502)
			},
			{
				id: 'اسپكه',
				name: 'اسپكه',
				coordinate: new Coordinates(26.8373584747314, 60.1723251342773)
			},
			{
				id: 'ايرانشهر',
				name: 'ايرانشهر',
				coordinate: new Coordinates(27.2041645050049, 60.6751289367676)
			},
			{
				id: 'بزمان',
				name: 'بزمان',
				coordinate: new Coordinates(27.8503456115723, 60.1754837036133)
			},
			{
				id: 'بمپور',
				name: 'بمپور',
				coordinate: new Coordinates(27.1937408447266, 60.4562187194824)
			},
			{
				id: 'بنت',
				name: 'بنت',
				coordinate: new Coordinates(26.2868232727051, 59.5226707458496)
			},
			{
				id: 'بنجار',
				name: 'بنجار',
				coordinate: new Coordinates(31.0428943634033, 61.5674514770508)
			},
			{
				id: 'پيشين',
				name: 'پيشين',
				coordinate: new Coordinates(26.07985496521, 61.7484016418457)
			},
			{
				id: 'جالق',
				name: 'جالق',
				coordinate: new Coordinates(27.5827865600586, 62.7007255554199)
			},
			{
				id: 'چاه بهار',
				name: 'چاه بهار',
				coordinate: new Coordinates(25.2945194244385, 60.6477012634277)
			},
			{
				id: 'خاش',
				name: 'خاش',
				coordinate: new Coordinates(28.209436416626, 61.2028617858887)
			},
			{
				id: 'دوست محمد',
				name: 'دوست محمد',
				coordinate: new Coordinates(31.1427326202393, 61.7928085327148)
			},
			{
				id: 'راسك',
				name: 'راسك',
				coordinate: new Coordinates(26.2332515716553, 61.4054412841797)
			},
			{
				id: 'زابل',
				name: 'زابل',
				coordinate: new Coordinates(31.0088672637939, 61.4938087463379)
			},
			{
				id: 'زابلي',
				name: 'زابلي',
				coordinate: new Coordinates(27.1145877838135, 61.6725997924805)
			},
			{
				id: 'زاهدان',
				name: 'زاهدان',
				coordinate: new Coordinates(29.4821357727051, 60.85205078125)
			},
			{
				id: 'زرآباد',
				name: 'زرآباد',
				coordinate: new Coordinates(25.5872364044189, 59.3962898254395)
			},
			{
				id: 'زهك',
				name: 'زهك',
				coordinate: new Coordinates(30.8931617736816, 61.6829261779785)
			},
			{
				id: 'سراوان',
				name: 'سراوان',
				coordinate: new Coordinates(27.3613433837891, 62.3330726623535)
			},
			{
				id: 'سرباز',
				name: 'سرباز',
				coordinate: new Coordinates(26.6332359313965, 61.2580604553223)
			},
			{
				id: 'سوران',
				name: 'سوران',
				coordinate: new Coordinates(27.2860298156738, 61.9948806762695)
			},
			{
				id: 'سيركان',
				name: 'سيركان',
				coordinate: new Coordinates(26.8298721313477, 62.6384811401367)
			},
			{
				id: 'علي اكبر',
				name: 'علي اكبر',
				coordinate: new Coordinates(30.939079284668, 61.3279647827148)
			},
			{
				id: 'فنوج',
				name: 'فنوج',
				coordinate: new Coordinates(26.5757274627686, 59.6449851989746)
			},
			{
				id: 'قصرقند',
				name: 'قصرقند',
				coordinate: new Coordinates(26.2130393981934, 60.7416763305664)
			},
			{
				id: 'كنارك',
				name: 'كنارك',
				coordinate: new Coordinates(25.3595199584961, 60.3969802856445)
			},
			{
				id: 'گشت',
				name: 'گشت',
				coordinate: new Coordinates(27.7886066436768, 61.9510879516602)
			},
			{
				id: 'گلمورتي',
				name: 'گلمورتي',
				coordinate: new Coordinates(27.4812297821045, 59.447322845459)
			},
			{
				id: 'محمدان',
				name: 'محمدان',
				coordinate: new Coordinates(27.1998977661133, 60.5608177185059)
			},
			{
				id: 'محمدآباد',
				name: 'محمدآباد',
				coordinate: new Coordinates(30.8729267120361, 61.4618644714355)
			},
			{
				id: 'محمدي',
				name: 'محمدي',
				coordinate: new Coordinates(27.3268337249756, 62.3901672363281)
			},
			{
				id: 'ميرجاوه',
				name: 'ميرجاوه',
				coordinate: new Coordinates(29.0156440734863, 61.4495468139648)
			},
			{
				id: 'نصرت آباد',
				name: 'نصرت آباد',
				coordinate: new Coordinates(29.857982635498, 59.9736595153809)
			},
			{
				id: 'نگور',
				name: 'نگور',
				coordinate: new Coordinates(25.3888053894043, 61.1399421691895)
			},
			{
				id: 'نوك آباد',
				name: 'نوك آباد',
				coordinate: new Coordinates(28.5391082763672, 60.7588806152344)
			},
			{
				id: 'نيك شهر',
				name: 'نيك شهر',
				coordinate: new Coordinates(26.2345523834229, 60.2268600463867)
			},
			{
				id: 'هيدوج',
				name: 'هيدوج',
				coordinate: new Coordinates(27.0020618438721, 62.1193695068359)
			}
		]
	},
	{
		name: 'فارس',
		cities: [
			{
				id: 'اردكان',
				name: 'اردكان',
				coordinate: new Coordinates(30.2320652008057, 51.9920501708984)
			},
			{
				id: 'ارسنجان',
				name: 'ارسنجان',
				coordinate: new Coordinates(29.9098110198975, 53.3006973266602)
			},
			{
				id: 'استهبان',
				name: 'استهبان',
				coordinate: new Coordinates(29.1260662078857, 54.0446281433106)
			},
			{
				id: 'اسير',
				name: 'اسير',
				coordinate: new Coordinates(27.7228317260742, 52.6656875610352)
			},
			{
				id: 'اشكنان',
				name: 'اشكنان',
				coordinate: new Coordinates(27.2255363464355, 53.6081733703613)
			},
			{
				id: 'افزر',
				name: 'افزر',
				coordinate: new Coordinates(28.3462944030762, 52.9656257629395)
			},
			{
				id: 'اقليد',
				name: 'اقليد',
				coordinate: new Coordinates(30.9019203186035, 52.7052612304688)
			},
			{
				id: 'امام شهر',
				name: 'امام شهر',
				coordinate: new Coordinates(28.4452362060547, 53.1506042480469)
			},
			{
				id: 'اوز',
				name: 'اوز',
				coordinate: new Coordinates(27.7578811645508, 54.012378692627)
			},
			{
				id: 'اهل',
				name: 'اهل',
				coordinate: new Coordinates(27.210994720459, 53.6597938537598)
			},
			{
				id: 'ايج',
				name: 'ايج',
				coordinate: new Coordinates(29.0201721191406, 54.2453842163086)
			},
			{
				id: 'ايزدخواست',
				name: 'ايزدخواست',
				coordinate: new Coordinates(31.5170097351074, 52.1249351501465)
			},
			{
				id: 'آباده',
				name: 'آباده',
				coordinate: new Coordinates(31.1429824829102, 52.6501159667969)
			},
			{
				id: 'آباده طشك',
				name: 'آباده طشك',
				coordinate: new Coordinates(29.8098621368408, 53.7306861877441)
			},
			{
				id: 'باب انار',
				name: 'باب انار',
				coordinate: new Coordinates(28.9684448242187, 53.2091445922852)
			},
			{
				id: 'بالاده',
				name: 'بالاده',
				coordinate: new Coordinates(29.2849922180176, 51.9389266967773)
			},
			{
				id: 'بنارويه',
				name: 'بنارويه',
				coordinate: new Coordinates(28.0866107940674, 54.0456314086914)
			},
			{
				id: 'بوانات',
				name: 'بوانات',
				coordinate: new Coordinates(30.4609355926514, 53.6389656066895)
			},
			{
				id: 'بهمن',
				name: 'بهمن',
				coordinate: new Coordinates(31.1948585510254, 52.4853096008301)
			},
			{
				id: 'بيرم',
				name: 'بيرم',
				coordinate: new Coordinates(27.4309120178223, 53.5151214599609)
			},
			{
				id: 'بيضا',
				name: 'بيضا',
				coordinate: new Coordinates(29.9708938598633, 52.3977584838867)
			},
			{
				id: 'جنت شهر',
				name: 'جنت شهر',
				coordinate: new Coordinates(28.6534748077393, 54.6851768493652)
			},
			{
				id: 'جويم',
				name: 'جويم',
				coordinate: new Coordinates(28.2615451812744, 53.9799537658691)
			},
			{
				id: 'جهرم',
				name: 'جهرم',
				coordinate: new Coordinates(28.4949188232422, 53.5668869018555)
			},
			{
				id: 'حاجي آباد',
				name: 'حاجي آباد',
				coordinate: new Coordinates(28.3574962615967, 54.4203147888184)
			},
			{
				id: 'حسامي',
				name: 'حسامي',
				coordinate: new Coordinates(29.9675426483154, 53.8724060058594)
			},
			{
				id: 'حسن آباد',
				name: 'حسن آباد',
				coordinate: new Coordinates(30.51979637146, 52.4560394287109)
			},
			{
				id: 'خانه زنيان',
				name: 'خانه زنيان',
				coordinate: new Coordinates(29.6711864471436, 52.1497039794922)
			},
			{
				id: 'خاوران',
				name: 'خاوران',
				coordinate: new Coordinates(28.9389381408691, 53.3130950927734)
			},
			{
				id: 'خرامه',
				name: 'خرامه',
				coordinate: new Coordinates(29.493049621582, 53.3100318908691)
			},
			{
				id: 'خشت',
				name: 'خشت',
				coordinate: new Coordinates(29.5542602539062, 51.3354415893555)
			},
			{
				id: 'خنج',
				name: 'خنج',
				coordinate: new Coordinates(27.8923320770264, 53.429615020752)
			},
			{
				id: 'خور',
				name: 'خور',
				coordinate: new Coordinates(27.6446285247803, 54.3439521789551)
			},
			{
				id: 'خومه زار',
				name: 'خومه زار',
				coordinate: new Coordinates(30.0063247680664, 51.5781211853027)
			},
			{
				id: 'داراب',
				name: 'داراب',
				coordinate: new Coordinates(28.7542610168457, 54.5471229553223)
			},
			{
				id: 'داريان',
				name: 'داريان',
				coordinate: new Coordinates(29.5603313446045, 52.9200897216797)
			},
			{
				id: 'دبيران',
				name: 'دبيران',
				coordinate: new Coordinates(28.3961620330811, 54.1868286132813)
			},
			{
				id: 'دژكرد',
				name: 'دژكرد',
				coordinate: new Coordinates(30.7136135101318, 51.9579429626465)
			},
			{
				id: 'دوبرجي',
				name: 'دوبرجي',
				coordinate: new Coordinates(28.3073406219482, 55.1925048828125)
			},
			{
				id: 'دوزه',
				name: 'دوزه',
				coordinate: new Coordinates(28.7010860443115, 52.9584922790527)
			},
			{
				id: 'دهرم',
				name: 'دهرم',
				coordinate: new Coordinates(28.493293762207, 52.3042221069336)
			},
			{
				id: 'رامجرد',
				name: 'رامجرد',
				coordinate: new Coordinates(30.0748805999756, 52.5926361083984)
			},
			{
				id: 'رونيز',
				name: 'رونيز',
				coordinate: new Coordinates(29.1920566558838, 53.769401550293)
			},
			{
				id: 'زاهدشهر',
				name: 'زاهدشهر',
				coordinate: new Coordinates(28.7466297149658, 53.8046493530274)
			},
			{
				id: 'زرقان',
				name: 'زرقان',
				coordinate: new Coordinates(29.773832321167, 52.7217788696289)
			},
			{
				id: 'سده',
				name: 'سده',
				coordinate: new Coordinates(30.710578918457, 52.1761169433594)
			},
			{
				id: 'سروستان',
				name: 'سروستان',
				coordinate: new Coordinates(29.2630271911621, 53.2238731384277)
			},
			{
				id: 'سعادت شهر',
				name: 'سعادت شهر',
				coordinate: new Coordinates(30.0742740631104, 53.1361312866211)
			},
			{
				id: 'سورمق',
				name: 'سورمق',
				coordinate: new Coordinates(31.0344886779785, 52.8395576477051)
			},
			{
				id: 'سيدان',
				name: 'سيدان',
				coordinate: new Coordinates(30.0044631958008, 53.0056762695313)
			},
			{
				id: 'ششده',
				name: 'ششده',
				coordinate: new Coordinates(28.9496421813965, 53.9957580566406)
			},
			{
				id: 'شهر جديد صدرا',
				name: 'شهر جديد صدرا',
				coordinate: new Coordinates(29.8010139465332, 52.5084953308105)
			},
			{
				id: 'شهرپير',
				name: 'شهرپير',
				coordinate: new Coordinates(28.311695098877, 54.3350334167481)
			},
			{
				id: 'شيراز',
				name: 'شيراز',
				coordinate: new Coordinates(29.5568904876709, 52.5291213989258)
			},
			{
				id: 'صغاد',
				name: 'صغاد',
				coordinate: new Coordinates(31.1910705566406, 52.5154342651367)
			},
			{
				id: 'صفاشهر',
				name: 'صفاشهر',
				coordinate: new Coordinates(30.6136665344238, 53.1987228393555)
			},
			{
				id: 'علامرودشت',
				name: 'علامرودشت',
				coordinate: new Coordinates(27.6244621276855, 53.000659942627)
			},
			{
				id: 'عمادده',
				name: 'عمادده',
				coordinate: new Coordinates(27.4446449279785, 53.8618354797363)
			},
			{
				id: 'فدامي',
				name: 'فدامي',
				coordinate: new Coordinates(28.2168083190918, 55.1351432800293)
			},
			{
				id: 'فراشبند',
				name: 'فراشبند',
				coordinate: new Coordinates(28.8588905334473, 52.09375)
			},
			{
				id: 'فسا',
				name: 'فسا',
				coordinate: new Coordinates(28.9197254180908, 53.6376914978027)
			},
			{
				id: 'فيروزآباد',
				name: 'فيروزآباد',
				coordinate: new Coordinates(28.84885597229, 52.5698013305664)
			},
			{
				id: 'قادرآباد',
				name: 'قادرآباد',
				coordinate: new Coordinates(30.2806663513184, 53.2550888061523)
			},
			{
				id: 'قائميه',
				name: 'قائميه',
				coordinate: new Coordinates(29.8443164825439, 51.5911064147949)
			},
			{
				id: 'قطب آباد',
				name: 'قطب آباد',
				coordinate: new Coordinates(28.6406745910645, 53.6394729614258)
			},
			{
				id: 'قطرويه',
				name: 'قطرويه',
				coordinate: new Coordinates(29.1460361480713, 54.7035522460938)
			},
			{
				id: 'قير',
				name: 'قير',
				coordinate: new Coordinates(28.4746170043945, 53.0439033508301)
			},
			{
				id: 'كارزين',
				name: 'كارزين',
				coordinate: new Coordinates(28.4087162017822, 53.1085243225098)
			},
			{
				id: 'كازرون',
				name: 'كازرون',
				coordinate: new Coordinates(29.6037464141846, 51.651798248291)
			},
			{
				id: 'كامفيروز',
				name: 'كامفيروز',
				coordinate: new Coordinates(30.3219833374023, 52.1942939758301)
			},
			{
				id: 'كره اي',
				name: 'كره اي',
				coordinate: new Coordinates(30.0297260284424, 53.7157554626465)
			},
			{
				id: 'كنارتخته',
				name: 'كنارتخته',
				coordinate: new Coordinates(29.5339126586914, 51.3949165344238)
			},
			{
				id: 'كوار',
				name: 'كوار',
				coordinate: new Coordinates(29.1960849761963, 52.6867179870605)
			},
			{
				id: 'كوهنجان',
				name: 'كوهنجان',
				coordinate: new Coordinates(29.2311305999756, 52.9561920166016)
			},
			{
				id: 'گراش',
				name: 'گراش',
				coordinate: new Coordinates(27.667142868042, 54.1450347900391)
			},
			{
				id: 'گله دار',
				name: 'گله دار',
				coordinate: new Coordinates(27.6488075256348, 52.6602058410645)
			},
			{
				id: 'لار',
				name: 'لار',
				coordinate: new Coordinates(27.6426486968994, 54.3203582763672)
			},
			{
				id: 'لامرد',
				name: 'لامرد',
				coordinate: new Coordinates(27.3299674987793, 53.1879196166992)
			},
			{
				id: 'لپوئي',
				name: 'لپوئي',
				coordinate: new Coordinates(29.799072265625, 52.6520729064941)
			},
			{
				id: 'لطيفي',
				name: 'لطيفي',
				coordinate: new Coordinates(27.6899585723877, 54.3867034912109)
			},
			{
				id: 'مبارك آباد',
				name: 'مبارك آباد',
				coordinate: new Coordinates(28.3601818084717, 53.3287010192871)
			},
			{
				id: 'مرودشت',
				name: 'مرودشت',
				coordinate: new Coordinates(29.8595104217529, 52.8102722167969)
			},
			{
				id: 'مشكان',
				name: 'مشكان',
				coordinate: new Coordinates(29.4728164672852, 54.3459129333496)
			},
			{
				id: 'مصيري',
				name: 'مصيري',
				coordinate: new Coordinates(30.2443103790283, 51.5289039611816)
			},
			{
				id: 'مهر',
				name: 'مهر',
				coordinate: new Coordinates(27.5504589080811, 52.8838500976562)
			},
			{
				id: 'ميمند',
				name: 'ميمند',
				coordinate: new Coordinates(28.8682880401611, 52.7509155273438)
			},
			{
				id: 'نوبندگان',
				name: 'نوبندگان',
				coordinate: new Coordinates(28.8538227081299, 53.8259201049805)
			},
			{
				id: 'نوجين',
				name: 'نوجين',
				coordinate: new Coordinates(29.125373840332, 52.0134887695312)
			},
			{
				id: 'نودان',
				name: 'نودان',
				coordinate: new Coordinates(29.8016605377197, 51.6942291259766)
			},
			{
				id: 'نورآباد',
				name: 'نورآباد',
				coordinate: new Coordinates(30.1148166656494, 51.5222511291504)
			},
			{
				id: 'ني ريز',
				name: 'ني ريز',
				coordinate: new Coordinates(29.1979217529297, 54.3226547241211)
			},
			{
				id: 'وراوي',
				name: 'وراوي',
				coordinate: new Coordinates(27.4650325775146, 53.0521850585938)
			},
			{
				id: 'هماشهر',
				name: 'هماشهر',
				coordinate: new Coordinates(30.1154232025146, 52.0876770019531)
			}
		]
	},
	{
		name: 'قزوين',
		cities: [
			{
				id: 'ارداق',
				name: 'ارداق',
				coordinate: new Coordinates(36.0533561706543, 49.8244171142578)
			},
			{
				id: 'اسفرورين',
				name: 'اسفرورين',
				coordinate: new Coordinates(35.9350814819336, 49.7502861022949)
			},
			{
				id: 'اقباليه',
				name: 'اقباليه',
				coordinate: new Coordinates(36.2320861816406, 49.9266624450684)
			},
			{
				id: 'الوند',
				name: 'الوند',
				coordinate: new Coordinates(36.1703414916992, 50.0741539001465)
			},
			{
				id: 'آبگرم',
				name: 'آبگرم',
				coordinate: new Coordinates(35.7574005126953, 49.287296295166)
			},
			{
				id: 'آبيك',
				name: 'آبيك',
				coordinate: new Coordinates(36.0398902893066, 50.5296974182129)
			},
			{
				id: 'آوج',
				name: 'آوج',
				coordinate: new Coordinates(35.5797805786133, 49.2218399047852)
			},
			{
				id: 'بوئين زهرا',
				name: 'بوئين زهرا',
				coordinate: new Coordinates(35.757152557373, 50.0619697570801)
			},
			{
				id: 'بيدستان',
				name: 'بيدستان',
				coordinate: new Coordinates(36.2312660217285, 50.1214027404785)
			},
			{
				id: 'تاكستان',
				name: 'تاكستان',
				coordinate: new Coordinates(36.071418762207, 49.696159362793)
			},
			{
				id: 'خاكعلي',
				name: 'خاكعلي',
				coordinate: new Coordinates(36.1288909912109, 50.1757774353027)
			},
			{
				id: 'خرمدشت',
				name: 'خرمدشت',
				coordinate: new Coordinates(35.9298439025879, 49.5117454528809)
			},
			{
				id: 'دانسفهان',
				name: 'دانسفهان',
				coordinate: new Coordinates(35.8116264343262, 49.7436027526855)
			},
			{
				id: 'رازميان',
				name: 'رازميان',
				coordinate: new Coordinates(36.536491394043, 50.2123374938965)
			},
			{
				id: 'سگزآباد',
				name: 'سگزآباد',
				coordinate: new Coordinates(35.7641296386719, 49.9394721984863)
			},
			{
				id: 'سيردان',
				name: 'سيردان',
				coordinate: new Coordinates(36.6515922546387, 49.1882133483887)
			},
			{
				id: 'شال',
				name: 'شال',
				coordinate: new Coordinates(35.8975982666016, 49.768367767334)
			},
			{
				id: 'شريفيه',
				name: 'شريفيه',
				coordinate: new Coordinates(36.2034111022949, 50.1513442993164)
			},
			{
				id: 'ضياءآباد',
				name: 'ضياءآباد',
				coordinate: new Coordinates(35.9955062866211, 49.4493370056152)
			},
			{
				id: 'قزوين',
				name: 'قزوين',
				coordinate: new Coordinates(36.2817459106445, 50.0019683837891)
			},
			{
				id: 'كوهين',
				name: 'كوهين',
				coordinate: new Coordinates(36.3728675842285, 49.6581077575684)
			},
			{
				id: 'محمديه',
				name: 'محمديه',
				coordinate: new Coordinates(36.2240180969238, 50.1825866699219)
			},
			{
				id: 'محمودآبادنمونه',
				name: 'محمودآبادنمونه',
				coordinate: new Coordinates(36.2904205322266, 49.9026412963867)
			},
			{
				id: 'معلم كلايه',
				name: 'معلم كلايه',
				coordinate: new Coordinates(36.4472770690918, 50.4781951904297)
			},
			{
				id: 'نرجه',
				name: 'نرجه',
				coordinate: new Coordinates(35.9920234680176, 49.6203308105469)
			}
		]
	},
	{
		name: 'قم',
		cities: [
			{
				id: 'جعفريه',
				name: 'جعفريه',
				coordinate: new Coordinates(34.7746391296387, 50.5166053771973)
			},
			{
				id: 'دستجرد',
				name: 'دستجرد',
				coordinate: new Coordinates(34.552848815918, 50.248218536377)
			},
			{
				id: 'سلفچگان',
				name: 'سلفچگان',
				coordinate: new Coordinates(34.4782638549805, 50.4576263427734)
			},
			{
				id: 'قم',
				name: 'قم',
				coordinate: new Coordinates(34.5939483642578, 50.8742904663086)
			},
			{
				id: 'قنوات',
				name: 'قنوات',
				coordinate: new Coordinates(34.611011505127, 51.0254707336426)
			},
			{
				id: 'كهك',
				name: 'كهك',
				coordinate: new Coordinates(34.3929252624512, 50.8641090393066)
			}
		]
	},
	{
		name: 'كردستان',
		cities: [
			{
				id: 'آرمرده',
				name: 'آرمرده',
				coordinate: new Coordinates(35.9293937683105, 45.7967300415039)
			},
			{
				id: 'بابارشاني',
				name: 'بابارشاني',
				coordinate: new Coordinates(35.6742248535156, 47.7974739074707)
			},
			{
				id: 'بانه',
				name: 'بانه',
				coordinate: new Coordinates(35.9957313537598, 45.888614654541)
			},
			{
				id: 'بلبان آباد',
				name: 'بلبان آباد',
				coordinate: new Coordinates(35.1371421813965, 47.3209915161133)
			},
			{
				id: 'بوئين سفلي',
				name: 'بوئين سفلي',
				coordinate: new Coordinates(35.9389801025391, 45.9362525939941)
			},
			{
				id: 'بيجار',
				name: 'بيجار',
				coordinate: new Coordinates(35.8828620910645, 47.6182594299316)
			},
			{
				id: 'چناره',
				name: 'چناره',
				coordinate: new Coordinates(35.6301193237305, 46.3091011047363)
			},
			{
				id: 'دزج',
				name: 'دزج',
				coordinate: new Coordinates(35.0647163391113, 47.963924407959)
			},
			{
				id: 'دلبران',
				name: 'دلبران',
				coordinate: new Coordinates(35.2384033203125, 47.9885711669922)
			},
			{
				id: 'دهگلان',
				name: 'دهگلان',
				coordinate: new Coordinates(35.2783355712891, 47.4189033508301)
			},
			{
				id: 'ديواندره',
				name: 'ديواندره',
				coordinate: new Coordinates(35.9124908447266, 47.0249061584473)
			},
			{
				id: 'زرينه',
				name: 'زرينه',
				coordinate: new Coordinates(36.0607261657715, 46.9187660217285)
			},
			{
				id: 'سروآباد',
				name: 'سروآباد',
				coordinate: new Coordinates(35.3117980957031, 46.3669891357422)
			},
			{
				id: 'سريش آباد',
				name: 'سريش آباد',
				coordinate: new Coordinates(35.2488136291504, 47.778491973877)
			},
			{
				id: 'سقز',
				name: 'سقز',
				coordinate: new Coordinates(36.2441177368164, 46.2729225158691)
			},
			{
				id: 'سنندج',
				name: 'سنندج',
				coordinate: new Coordinates(35.2403144836426, 47.0064086914063)
			},
			{
				id: 'شويشه',
				name: 'شويشه',
				coordinate: new Coordinates(35.352912902832, 46.6784553527832)
			},
			{
				id: 'صاحب',
				name: 'صاحب',
				coordinate: new Coordinates(36.2030944824219, 46.461856842041)
			},
			{
				id: 'قروه',
				name: 'قروه',
				coordinate: new Coordinates(35.1636009216309, 47.8100433349609)
			},
			{
				id: 'كامياران',
				name: 'كامياران',
				coordinate: new Coordinates(34.7971687316895, 46.9394645690918)
			},
			{
				id: 'كاني دينار',
				name: 'كاني دينار',
				coordinate: new Coordinates(35.4675331115723, 46.2033386230469)
			},
			{
				id: 'كاني سور',
				name: 'كاني سور',
				coordinate: new Coordinates(36.0590591430664, 45.7488212585449)
			},
			{
				id: 'مريوان',
				name: 'مريوان',
				coordinate: new Coordinates(35.5178718566895, 46.1809692382812)
			},
			{
				id: 'موچش',
				name: 'موچش',
				coordinate: new Coordinates(35.0591430664062, 47.1544876098633)
			},
			{
				id: 'ياسوكند',
				name: 'ياسوكند',
				coordinate: new Coordinates(36.2833938598633, 47.7468147277832)
			}
		]
	},
	{
		name: 'كرمان',
		cities: [
			{
				id: 'اختيارآباد',
				name: 'اختيارآباد',
				coordinate: new Coordinates(30.3197231292725, 56.9182777404785)
			},
			{
				id: 'ارزوئيه',
				name: 'ارزوئيه',
				coordinate: new Coordinates(28.4579296112061, 56.363525390625)
			},
			{
				id: 'امين شهر',
				name: 'امين شهر',
				coordinate: new Coordinates(30.8438282012939, 55.3393669128418)
			},
			{
				id: 'انار',
				name: 'انار',
				coordinate: new Coordinates(30.8725490570068, 55.2716293334961)
			},
			{
				id: 'اندوهجرد',
				name: 'اندوهجرد',
				coordinate: new Coordinates(30.2310314178467, 57.7540626525879)
			},
			{
				id: 'باغين',
				name: 'باغين',
				coordinate: new Coordinates(30.1893825531006, 56.8132247924805)
			},
			{
				id: 'بافت',
				name: 'بافت',
				coordinate: new Coordinates(29.2321758270264, 56.5969924926758)
			},
			{
				id: 'بردسير',
				name: 'بردسير',
				coordinate: new Coordinates(29.9241008758545, 56.5787696838379)
			},
			{
				id: 'بروات',
				name: 'بروات',
				coordinate: new Coordinates(29.0470066070557, 58.4085884094238)
			},
			{
				id: 'بزنجان',
				name: 'بزنجان',
				coordinate: new Coordinates(29.2548351287842, 56.6942825317383)
			},
			{
				id: 'بم',
				name: 'بم',
				coordinate: new Coordinates(29.067798614502, 58.3486175537109)
			},
			{
				id: 'بهرمان',
				name: 'بهرمان',
				coordinate: new Coordinates(30.904317855835, 55.7273864746094)
			},
			{
				id: 'پاريز',
				name: 'پاريز',
				coordinate: new Coordinates(29.8726215362549, 55.7505416870117)
			},
			{
				id: 'جبالبارز',
				name: 'جبالبارز',
				coordinate: new Coordinates(28.9060211181641, 57.8827476501465)
			},
			{
				id: 'جوپار',
				name: 'جوپار',
				coordinate: new Coordinates(30.0565242767334, 57.1124038696289)
			},
			{
				id: 'جوزم',
				name: 'جوزم',
				coordinate: new Coordinates(30.5151195526123, 55.0317344665527)
			},
			{
				id: 'جيرفت',
				name: 'جيرفت',
				coordinate: new Coordinates(28.6803932189941, 57.7419738769531)
			},
			{
				id: 'چترود',
				name: 'چترود',
				coordinate: new Coordinates(30.6010189056396, 56.9091682434082)
			},
			{
				id: 'خاتون آباد',
				name: 'خاتون آباد',
				coordinate: new Coordinates(29.9971446990967, 55.4199447631836)
			},
			{
				id: 'خانوك',
				name: 'خانوك',
				coordinate: new Coordinates(30.7177200317383, 56.7755432128906)
			},
			{
				id: 'خورسند',
				name: 'خورسند',
				coordinate: new Coordinates(30.1534004211426, 55.0875816345215)
			},
			{
				id: 'درب بهشت',
				name: 'درب بهشت',
				coordinate: new Coordinates(29.2335548400879, 57.3366737365723)
			},
			{
				id: 'دوساري',
				name: 'دوساري',
				coordinate: new Coordinates(28.423189163208, 57.9446907043457)
			},
			{
				id: 'دهج',
				name: 'دهج',
				coordinate: new Coordinates(30.6871662139893, 54.8781776428223)
			},
			{
				id: 'رابر',
				name: 'رابر',
				coordinate: new Coordinates(29.289909362793, 56.912956237793)
			},
			{
				id: 'راور',
				name: 'راور',
				coordinate: new Coordinates(31.2422618865967, 56.7984237670899)
			},
			{
				id: 'راين',
				name: 'راين',
				coordinate: new Coordinates(29.5988807678223, 57.435115814209)
			},
			{
				id: 'رفسنجان',
				name: 'رفسنجان',
				coordinate: new Coordinates(30.3752765655518, 55.9876480102539)
			},
			{
				id: 'رودبار',
				name: 'رودبار',
				coordinate: new Coordinates(28.0208168029785, 57.9945793151856)
			},
			{
				id: 'ريحان شهر',
				name: 'ريحان شهر',
				coordinate: new Coordinates(30.7513370513916, 56.7360801696777)
			},
			{
				id: 'زرند',
				name: 'زرند',
				coordinate: new Coordinates(30.8117275238037, 56.551872253418)
			},
			{
				id: 'زنگي آباد',
				name: 'زنگي آباد',
				coordinate: new Coordinates(30.41259765625, 56.9147338867188)
			},
			{
				id: 'زيدآباد',
				name: 'زيدآباد',
				coordinate: new Coordinates(29.5985698699951, 55.5349082946777)
			},
			{
				id: 'سرچشمه',
				name: 'سرچشمه',
				coordinate: new Coordinates(29.9973373413086, 55.7947235107422)
			},
			{
				id: 'سيرجان',
				name: 'سيرجان',
				coordinate: new Coordinates(29.4376163482666, 55.6749076843262)
			},
			{
				id: 'شهداد',
				name: 'شهداد',
				coordinate: new Coordinates(30.4166812896729, 57.7017097473145)
			},
			{
				id: 'شهربابك',
				name: 'شهربابك',
				coordinate: new Coordinates(30.1183261871338, 55.1207885742187)
			},
			{
				id: 'صفائيه',
				name: 'صفائيه',
				coordinate: new Coordinates(30.827823638916, 55.8113784790039)
			},
			{
				id: 'عنبرآباد',
				name: 'عنبرآباد',
				coordinate: new Coordinates(28.4789180755615, 57.8425254821777)
			},
			{
				id: 'فارياب',
				name: 'فارياب',
				coordinate: new Coordinates(28.0970840454102, 57.2282791137695)
			},
			{
				id: 'فهرج',
				name: 'فهرج',
				coordinate: new Coordinates(28.9478435516357, 58.8851127624512)
			},
			{
				id: 'قلعه گنج',
				name: 'قلعه گنج',
				coordinate: new Coordinates(27.5163536071777, 57.8829689025879)
			},
			{
				id: 'كاظم آباد',
				name: 'كاظم آباد',
				coordinate: new Coordinates(30.5605564117432, 56.8436584472656)
			},
			{
				id: 'كرمان',
				name: 'كرمان',
				coordinate: new Coordinates(30.2814025878906, 57.0641822814941)
			},
			{
				id: 'كشكوئيه',
				name: 'كشكوئيه',
				coordinate: new Coordinates(30.5305233001709, 55.6446189880371)
			},
			{
				id: 'كوهبنان',
				name: 'كوهبنان',
				coordinate: new Coordinates(31.4131984710693, 56.2793350219727)
			},
			{
				id: 'كهنوج',
				name: 'كهنوج',
				coordinate: new Coordinates(27.9224548339844, 57.6970748901367)
			},
			{
				id: 'كيانشهر',
				name: 'كيانشهر',
				coordinate: new Coordinates(31.1560039520264, 56.3811111450195)
			},
			{
				id: 'گلباف',
				name: 'گلباف',
				coordinate: new Coordinates(29.8844203948975, 57.731086730957)
			},
			{
				id: 'گلزار',
				name: 'گلزار',
				coordinate: new Coordinates(29.7112483978271, 57.0401115417481)
			},
			{
				id: 'لاله زار',
				name: 'لاله زار',
				coordinate: new Coordinates(29.5229511260986, 56.8163528442383)
			},
			{
				id: 'ماهان',
				name: 'ماهان',
				coordinate: new Coordinates(30.0579090118408, 57.2897453308106)
			},
			{
				id: 'محمدآباد',
				name: 'محمدآباد',
				coordinate: new Coordinates(28.6416683197021, 59.0174674987793)
			},
			{
				id: 'محي آباد',
				name: 'محي آباد',
				coordinate: new Coordinates(30.0716743469238, 57.230110168457)
			},
			{
				id: 'مردهك',
				name: 'مردهك',
				coordinate: new Coordinates(28.3499088287353, 58.1599197387695)
			},
			{
				id: 'منوجان',
				name: 'منوجان',
				coordinate: new Coordinates(27.4036674499512, 57.4967575073242)
			},
			{
				id: 'نجف شهر',
				name: 'نجف شهر',
				coordinate: new Coordinates(29.3912334442139, 55.7205696105957)
			},
			{
				id: 'نرماشير',
				name: 'نرماشير',
				coordinate: new Coordinates(28.9515285491943, 58.699405670166)
			},
			{
				id: 'نظام شهر',
				name: 'نظام شهر',
				coordinate: new Coordinates(28.9130706787109, 58.5514335632324)
			},
			{
				id: 'نگار',
				name: 'نگار',
				coordinate: new Coordinates(29.8572177886963, 56.8029174804687)
			},
			{
				id: 'نودژ',
				name: 'نودژ',
				coordinate: new Coordinates(27.527156829834, 57.4494247436523)
			},
			{
				id: 'هجدك',
				name: 'هجدك',
				coordinate: new Coordinates(30.7576065063477, 56.9962043762207)
			},
			{
				id: 'هماشهر',
				name: 'هماشهر',
				coordinate: new Coordinates(29.6626358032227, 55.8096656799316)
			},
			{
				id: 'يزدان شهر',
				name: 'يزدان شهر',
				coordinate: new Coordinates(30.86643409729, 56.3758926391602)
			}
		]
	},
	{
		name: 'كرمانشاه',
		cities: [
			{
				id: 'ازگله',
				name: 'ازگله',
				coordinate: new Coordinates(34.8334007263184, 45.8419189453125)
			},
			{
				id: 'اسلام آبادغرب',
				name: 'اسلام آبادغرب',
				coordinate: new Coordinates(34.1096153259277, 46.5205688476563)
			},
			{
				id: 'باينگان',
				name: 'باينگان',
				coordinate: new Coordinates(34.9814071655273, 46.2704124450684)
			},
			{
				id: 'بيستون',
				name: 'بيستون',
				coordinate: new Coordinates(34.3945846557617, 47.4476852416992)
			},
			{
				id: 'پاوه',
				name: 'پاوه',
				coordinate: new Coordinates(35.0266914367676, 46.3669662475586)
			},
			{
				id: 'تازه آباد',
				name: 'تازه آباد',
				coordinate: new Coordinates(34.7386207580566, 46.1516151428223)
			},
			{
				id: 'جوانرود',
				name: 'جوانرود',
				coordinate: new Coordinates(34.8061637878418, 46.4921913146973)
			},
			{
				id: 'حميل',
				name: 'حميل',
				coordinate: new Coordinates(33.9380111694336, 46.7728652954102)
			},
			{
				id: 'رباط',
				name: 'رباط',
				coordinate: new Coordinates(34.2685928344727, 46.8064117431641)
			},
			{
				id: 'روانسر',
				name: 'روانسر',
				coordinate: new Coordinates(34.716178894043, 46.6560707092285)
			},
			{
				id: 'سرپل ذهاب',
				name: 'سرپل ذهاب',
				coordinate: new Coordinates(34.4486808776855, 45.8630256652832)
			},
			{
				id: 'سرمست',
				name: 'سرمست',
				coordinate: new Coordinates(34.0269546508789, 46.3317527770996)
			},
			{
				id: 'سطر',
				name: 'سطر',
				coordinate: new Coordinates(34.8133888244629, 47.4608764648437)
			},
			{
				id: 'سنقر',
				name: 'سنقر',
				coordinate: new Coordinates(34.7627067565918, 47.5996322631836)
			},
			{
				id: 'سومار',
				name: 'سومار',
				coordinate: new Coordinates(33.865535736084, 45.6409721374512)
			},
			{
				id: 'شاهو',
				name: 'شاهو',
				coordinate: new Coordinates(34.9307899475098, 46.461109161377)
			},
			{
				id: 'صحنه',
				name: 'صحنه',
				coordinate: new Coordinates(34.4755172729492, 47.6852188110352)
			},
			{
				id: 'قصرشيرين',
				name: 'قصرشيرين',
				coordinate: new Coordinates(34.5075302124023, 45.5892906188965)
			},
			{
				id: 'كرمانشاه',
				name: 'كرمانشاه',
				coordinate: new Coordinates(34.314094543457, 47.0971412658691)
			},
			{
				id: 'كرندغرب',
				name: 'كرندغرب',
				coordinate: new Coordinates(34.2787055969238, 46.2320365905762)
			},
			{
				id: 'كنگاور',
				name: 'كنگاور',
				coordinate: new Coordinates(34.5016670227051, 47.9620208740234)
			},
			{
				id: 'كوزران',
				name: 'كوزران',
				coordinate: new Coordinates(34.4957618713379, 46.6020736694336)
			},
			{
				id: 'گهواره',
				name: 'گهواره',
				coordinate: new Coordinates(34.3440818786621, 46.4158592224121)
			},
			{
				id: 'گيلانغرب',
				name: 'گيلانغرب',
				coordinate: new Coordinates(34.1403198242187, 45.9247665405273)
			},
			{
				id: 'ميان راهان',
				name: 'ميان راهان',
				coordinate: new Coordinates(34.5838813781738, 47.4446678161621)
			},
			{
				id: 'نودشه',
				name: 'نودشه',
				coordinate: new Coordinates(35.1805038452148, 46.2534065246582)
			},
			{
				id: 'نوسود',
				name: 'نوسود',
				coordinate: new Coordinates(35.1575126647949, 46.2065391540527)
			},
			{
				id: 'هرسين',
				name: 'هرسين',
				coordinate: new Coordinates(34.2700042724609, 47.5803756713867)
			},
			{
				id: 'هلشي',
				name: 'هلشي',
				coordinate: new Coordinates(34.1101531982422, 47.0904312133789)
			}
		]
	},
	{
		name: 'كهگيلويه وبويراحمد',
		cities: [
			{
				id: 'باشت',
				name: 'باشت',
				coordinate: new Coordinates(30.3621273040771, 51.1563262939453)
			},
			{
				id: 'پاتاوه',
				name: 'پاتاوه',
				coordinate: new Coordinates(30.9525718688965, 51.270751953125)
			},
			{
				id: 'چرام',
				name: 'چرام',
				coordinate: new Coordinates(30.7554721832275, 50.7468414306641)
			},
			{
				id: 'چيتاب',
				name: 'چيتاب',
				coordinate: new Coordinates(30.7949180603027, 51.3247375488281)
			},
			{
				id: 'دوگنبدان',
				name: 'دوگنبدان',
				coordinate: new Coordinates(30.3634624481201, 50.7830123901367)
			},
			{
				id: 'دهدشت',
				name: 'دهدشت',
				coordinate: new Coordinates(30.7952117919922, 50.5633506774902)
			},
			{
				id: 'ديشموك',
				name: 'ديشموك',
				coordinate: new Coordinates(31.2985229492187, 50.4017677307129)
			},
			{
				id: 'سوق',
				name: 'سوق',
				coordinate: new Coordinates(30.8556518554687, 50.4598388671875)
			},
			{
				id: 'سي سخت',
				name: 'سي سخت',
				coordinate: new Coordinates(30.8575649261475, 51.4587287902832)
			},
			{
				id: 'قلعه رئيسي',
				name: 'قلعه رئيسي',
				coordinate: new Coordinates(31.1903476715088, 50.4440116882324)
			},
			{
				id: 'گراب سفلي',
				name: 'گراب سفلي',
				coordinate: new Coordinates(30.9445819854736, 50.8993682861328)
			},
			{
				id: 'لنده',
				name: 'لنده',
				coordinate: new Coordinates(30.9826679229736, 50.4196891784668)
			},
			{
				id: 'ليكك',
				name: 'ليكك',
				coordinate: new Coordinates(30.8971843719482, 50.0928344726563)
			},
			{
				id: 'مادوان',
				name: 'مادوان',
				coordinate: new Coordinates(30.7121486663818, 51.5545654296875)
			},
			{
				id: 'مارگون',
				name: 'مارگون',
				coordinate: new Coordinates(30.9933414459228, 51.0781402587891)
			},
			{
				id: 'ياسوج',
				name: 'ياسوج',
				coordinate: new Coordinates(30.6567630767822, 51.5824241638184)
			}
		]
	},
	{
		name: 'گلستان',
		cities: [
			{
				id: 'انبارآلوم',
				name: 'انبارآلوم',
				coordinate: new Coordinates(37.1327247619629, 54.6186332702637)
			},
			{
				id: 'اينچه برون',
				name: 'اينچه برون',
				coordinate: new Coordinates(37.4538345336914, 54.7190017700195)
			},
			{
				id: 'آزادشهر',
				name: 'آزادشهر',
				coordinate: new Coordinates(37.0866317749023, 55.1694793701172)
			},
			{
				id: 'آق قلا',
				name: 'آق قلا',
				coordinate: new Coordinates(37.0095405578613, 54.4567451477051)
			},
			{
				id: 'بندرگز',
				name: 'بندرگز',
				coordinate: new Coordinates(36.7540588378906, 53.9507141113281)
			},
			{
				id: 'تركمن',
				name: 'تركمن',
				coordinate: new Coordinates(36.9030113220215, 54.0750198364258)
			},
			{
				id: 'جلين',
				name: 'جلين',
				coordinate: new Coordinates(36.8546447753906, 54.5367431640625)
			},
			{
				id: 'خان ببين',
				name: 'خان ببين',
				coordinate: new Coordinates(37.0126800537109, 54.9878158569336)
			},
			{
				id: 'دلند',
				name: 'دلند',
				coordinate: new Coordinates(37.0352478027344, 55.0422592163086)
			},
			{
				id: 'راميان',
				name: 'راميان',
				coordinate: new Coordinates(37.0184516906738, 55.1420783996582)
			},
			{
				id: 'سرخنكلاته',
				name: 'سرخنكلاته',
				coordinate: new Coordinates(36.8829803466797, 54.569393157959)
			},
			{
				id: 'سيمين شهر',
				name: 'سيمين شهر',
				coordinate: new Coordinates(37.0112991333008, 54.2320899963379)
			},
			{
				id: 'علي آباد',
				name: 'علي آباد',
				coordinate: new Coordinates(36.9124031066895, 54.8577003479004)
			},
			{
				id: 'فاضل آباد',
				name: 'فاضل آباد',
				coordinate: new Coordinates(36.8994674682617, 54.7512702941895)
			},
			{
				id: 'كردكوي',
				name: 'كردكوي',
				coordinate: new Coordinates(36.7945251464844, 54.1099166870117)
			},
			{
				id: 'كلاله',
				name: 'كلاله',
				coordinate: new Coordinates(37.3811225891113, 55.4916152954102)
			},
			{
				id: 'گاليكش',
				name: 'گاليكش',
				coordinate: new Coordinates(37.2704048156738, 55.4310722351074)
			},
			{
				id: 'گرگان',
				name: 'گرگان',
				coordinate: new Coordinates(36.8451995849609, 54.4287986755371)
			},
			{
				id: 'گميش تپه',
				name: 'گميش تپه',
				coordinate: new Coordinates(37.0716590881348, 54.0754203796387)
			},
			{
				id: 'گنبد كاووس',
				name: 'گنبد كاووس',
				coordinate: new Coordinates(37.2478141784668, 55.1757392883301)
			},
			{
				id: 'مراوه تپه',
				name: 'مراوه تپه',
				coordinate: new Coordinates(37.9047088623047, 55.961727142334)
			},
			{
				id: 'مينودشت',
				name: 'مينودشت',
				coordinate: new Coordinates(37.2296600341797, 55.3750877380371)
			},
			{
				id: 'نگين شهر',
				name: 'نگين شهر',
				coordinate: new Coordinates(37.1390571594238, 55.1641464233398)
			},
			{
				id: 'نوده خاندوز',
				name: 'نوده خاندوز',
				coordinate: new Coordinates(37.0762672424316, 55.2622222900391)
			},
			{
				id: 'نوكنده',
				name: 'نوكنده',
				coordinate: new Coordinates(36.7397651672363, 53.9131202697754)
			}
		]
	},
	{
		name: 'گيلان',
		cities: [
			{
				id: 'احمدسرگوراب',
				name: 'احمدسرگوراب',
				coordinate: new Coordinates(37.1335983276367, 49.3679275512695)
			},
			{
				id: 'اسالم',
				name: 'اسالم',
				coordinate: new Coordinates(37.7357025146484, 48.945873260498)
			},
			{
				id: 'اطاقور',
				name: 'اطاقور',
				coordinate: new Coordinates(37.1101684570313, 50.1138687133789)
			},
			{
				id: 'املش',
				name: 'املش',
				coordinate: new Coordinates(37.0872116088867, 50.1910285949707)
			},
			{
				id: 'آستارا',
				name: 'آستارا',
				coordinate: new Coordinates(38.3871803283691, 48.8692474365234)
			},
			{
				id: 'آستانه اشرفيه',
				name: 'آستانه اشرفيه',
				coordinate: new Coordinates(37.2635917663574, 49.9449081420898)
			},
			{
				id: 'بازارجمعه',
				name: 'بازارجمعه',
				coordinate: new Coordinates(37.4068183898926, 49.1182670593262)
			},
			{
				id: 'بره سر',
				name: 'بره سر',
				coordinate: new Coordinates(36.776725769043, 49.7524108886719)
			},
			{
				id: 'بندرانزلي',
				name: 'بندرانزلي',
				coordinate: new Coordinates(37.4667053222656, 49.4626998901367)
			},
			{
				id: 'پره سر',
				name: 'پره سر',
				coordinate: new Coordinates(37.6034317016602, 49.0693817138672)
			},
			{
				id: 'توتكابن',
				name: 'توتكابن',
				coordinate: new Coordinates(36.8939094543457, 49.5256690979004)
			},
			{
				id: 'جيرنده',
				name: 'جيرنده',
				coordinate: new Coordinates(36.7013282775879, 49.7905616760254)
			},
			{
				id: 'چابكسر',
				name: 'چابكسر',
				coordinate: new Coordinates(36.9746398925781, 50.5547218322754)
			},
			{
				id: 'چاف وچمخاله',
				name: 'چاف وچمخاله',
				coordinate: new Coordinates(37.2164649963379, 50.2256584167481)
			},
			{
				id: 'چوبر',
				name: 'چوبر',
				coordinate: new Coordinates(37.0896263122559, 49.4218254089356)
			},
			{
				id: 'حويق',
				name: 'حويق',
				coordinate: new Coordinates(38.1542205810547, 48.8903465270996)
			},
			{
				id: 'خشكبيجار',
				name: 'خشكبيجار',
				coordinate: new Coordinates(37.3741455078125, 49.7586975097656)
			},
			{
				id: 'خمام',
				name: 'خمام',
				coordinate: new Coordinates(37.382152557373, 49.6518440246582)
			},
			{
				id: 'ديلمان',
				name: 'ديلمان',
				coordinate: new Coordinates(36.8835411071777, 49.9071426391602)
			},
			{
				id: 'رانكوه',
				name: 'رانكوه',
				coordinate: new Coordinates(37.0497741699219, 50.2364845275879)
			},
			{
				id: 'رحيم آباد',
				name: 'رحيم آباد',
				coordinate: new Coordinates(37.0331649780273, 50.3370513916016)
			},
			{
				id: 'رستم آباد',
				name: 'رستم آباد',
				coordinate: new Coordinates(36.8840713500977, 49.4915733337402)
			},
			{
				id: 'رشت',
				name: 'رشت',
				coordinate: new Coordinates(37.2841453552246, 49.5904083251953)
			},
			{
				id: 'رضوانشهر',
				name: 'رضوانشهر',
				coordinate: new Coordinates(37.5505561828613, 49.1397018432617)
			},
			{
				id: 'رودبار',
				name: 'رودبار',
				coordinate: new Coordinates(36.8066596984863, 49.4189758300781)
			},
			{
				id: 'رودبنه',
				name: 'رودبنه',
				coordinate: new Coordinates(37.256591796875, 50.0082054138184)
			},
			{
				id: 'رودسر',
				name: 'رودسر',
				coordinate: new Coordinates(37.1326484680176, 50.3002548217773)
			},
			{
				id: 'سنگر',
				name: 'سنگر',
				coordinate: new Coordinates(37.179141998291, 49.6977157592773)
			},
			{
				id: 'سياهكل',
				name: 'سياهكل',
				coordinate: new Coordinates(37.1510925292969, 49.872371673584)
			},
			{
				id: 'شفت',
				name: 'شفت',
				coordinate: new Coordinates(37.1638145446777, 49.4030914306641)
			},
			{
				id: 'شلمان',
				name: 'شلمان',
				coordinate: new Coordinates(37.1599006652832, 50.2166519165039)
			},
			{
				id: 'صومعه سرا',
				name: 'صومعه سرا',
				coordinate: new Coordinates(37.3028335571289, 49.3201217651367)
			},
			{
				id: 'فومن',
				name: 'فومن',
				coordinate: new Coordinates(37.225700378418, 49.3110008239746)
			},
			{
				id: 'كلاچاي',
				name: 'كلاچاي',
				coordinate: new Coordinates(37.0746803283691, 50.3994026184082)
			},
			{
				id: 'كوچصفهان',
				name: 'كوچصفهان',
				coordinate: new Coordinates(37.2771644592285, 49.768138885498)
			},
			{
				id: 'كومله',
				name: 'كومله',
				coordinate: new Coordinates(37.1506271362305, 50.1761817932129)
			},
			{
				id: 'كياشهر',
				name: 'كياشهر',
				coordinate: new Coordinates(37.4223365783691, 49.930534362793)
			},
			{
				id: 'گوراب زرميخ',
				name: 'گوراب زرميخ',
				coordinate: new Coordinates(37.3001594543457, 49.2186317443848)
			},
			{
				id: 'لاهيجان',
				name: 'لاهيجان',
				coordinate: new Coordinates(37.202392578125, 50.0108184814453)
			},
			{
				id: 'لشت نشاء',
				name: 'لشت نشاء',
				coordinate: new Coordinates(37.3623886108398, 49.8618431091309)
			},
			{
				id: 'لنگرود',
				name: 'لنگرود',
				coordinate: new Coordinates(37.1956748962402, 50.1474266052246)
			},
			{
				id: 'لوشان',
				name: 'لوشان',
				coordinate: new Coordinates(36.6312561035156, 49.5147705078125)
			},
			{
				id: 'لولمان',
				name: 'لولمان',
				coordinate: new Coordinates(37.2523498535156, 49.8250846862793)
			},
			{
				id: 'لوندويل',
				name: 'لوندويل',
				coordinate: new Coordinates(38.309268951416, 48.8634910583496)
			},
			{
				id: 'ليسار',
				name: 'ليسار',
				coordinate: new Coordinates(37.9374885559082, 48.9162368774414)
			},
			{
				id: 'ماسال',
				name: 'ماسال',
				coordinate: new Coordinates(37.3655014038086, 49.1317672729492)
			},
			{
				id: 'ماسوله',
				name: 'ماسوله',
				coordinate: new Coordinates(37.1560363769531, 48.9893798828125)
			},
			{
				id: 'مرجقل',
				name: 'مرجقل',
				coordinate: new Coordinates(37.2835998535156, 49.3794860839844)
			},
			{
				id: 'منجيل',
				name: 'منجيل',
				coordinate: new Coordinates(36.7412986755371, 49.4185409545898)
			},
			{
				id: 'واجارگاه',
				name: 'واجارگاه',
				coordinate: new Coordinates(37.0417518615723, 50.4137382507324)
			},
			{
				id: 'هشتپر',
				name: 'هشتپر',
				coordinate: new Coordinates(37.7955589294434, 48.9043807983398)
			}
		]
	},
	{
		name: 'لرستان',
		cities: [
			{
				id: 'ازنا',
				name: 'ازنا',
				coordinate: new Coordinates(33.4573287963867, 49.4542121887207)
			},
			{
				id: 'اشترينان',
				name: 'اشترينان',
				coordinate: new Coordinates(34.017406463623, 48.6421852111816)
			},
			{
				id: 'الشتر',
				name: 'الشتر',
				coordinate: new Coordinates(33.8614082336426, 48.259765625)
			},
			{
				id: 'اليگودرز',
				name: 'اليگودرز',
				coordinate: new Coordinates(33.4015464782715, 49.6931686401367)
			},
			{
				id: 'بروجرد',
				name: 'بروجرد',
				coordinate: new Coordinates(33.8982925415039, 48.7546806335449)
			},
			{
				id: 'پلدختر',
				name: 'پلدختر',
				coordinate: new Coordinates(33.1529273986816, 47.7143173217773)
			},
			{
				id: 'چالانچولان',
				name: 'چالانچولان',
				coordinate: new Coordinates(33.6646156311035, 48.9066581726074)
			},
			{
				id: 'چغلوندي',
				name: 'چغلوندي',
				coordinate: new Coordinates(33.6491737365723, 48.5595436096191)
			},
			{
				id: 'چقابل',
				name: 'چقابل',
				coordinate: new Coordinates(33.2818489074707, 47.5080184936523)
			},
			{
				id: 'خرم آباد',
				name: 'خرم آباد',
				coordinate: new Coordinates(33.4569625854492, 48.3489112854004)
			},
			{
				id: 'درب گنبد',
				name: 'درب گنبد',
				coordinate: new Coordinates(33.6907615661621, 47.1482963562012)
			},
			{
				id: 'دورود',
				name: 'دورود',
				coordinate: new Coordinates(33.4942016601562, 49.0568084716797)
			},
			{
				id: 'زاغه',
				name: 'زاغه',
				coordinate: new Coordinates(33.4957275390625, 48.7075462341309)
			},
			{
				id: 'سپيددشت',
				name: 'سپيددشت',
				coordinate: new Coordinates(33.2197761535645, 48.8839111328125)
			},
			{
				id: 'سراب دوره',
				name: 'سراب دوره',
				coordinate: new Coordinates(33.5631103515625, 48.0200538635254)
			},
			{
				id: 'شول آباد',
				name: 'شول آباد',
				coordinate: new Coordinates(33.1855888366699, 49.1909103393555)
			},
			{
				id: 'فيروزآباد',
				name: 'فيروزآباد',
				coordinate: new Coordinates(33.8990325927734, 48.1031074523926)
			},
			{
				id: 'كوناني',
				name: 'كوناني',
				coordinate: new Coordinates(33.4024696350098, 47.325439453125)
			},
			{
				id: 'كوهدشت',
				name: 'كوهدشت',
				coordinate: new Coordinates(33.5341529846191, 47.6084632873535)
			},
			{
				id: 'گراب',
				name: 'گراب',
				coordinate: new Coordinates(33.4741363525391, 47.2369995117188)
			},
			{
				id: 'معمولان',
				name: 'معمولان',
				coordinate: new Coordinates(33.3794097900391, 47.9618835449219)
			},
			{
				id: 'مؤمن آباد',
				name: 'مؤمن آباد',
				coordinate: new Coordinates(33.5847854614258, 49.518482208252)
			},
			{
				id: 'نورآباد',
				name: 'نورآباد',
				coordinate: new Coordinates(34.0703964233398, 47.9731941223145)
			},
			{
				id: 'ويسيان',
				name: 'ويسيان',
				coordinate: new Coordinates(33.486198425293, 48.0303382873535)
			},
			{
				id: 'هفت چشمه',
				name: 'هفت چشمه',
				coordinate: new Coordinates(34.2040557861328, 47.7596626281738)
			}
		]
	},
	{
		name: 'مازندران',
		cities: [
			{
				id: 'اميركلا',
				name: 'اميركلا',
				coordinate: new Coordinates(36.5987815856934, 52.6627388000488)
			},
			{
				id: 'ايزدشهر',
				name: 'ايزدشهر',
				coordinate: new Coordinates(36.6012916564941, 52.1393775939941)
			},
			{
				id: 'آلاشت',
				name: 'آلاشت',
				coordinate: new Coordinates(36.0663604736328, 52.8379135131836)
			},
			{
				id: 'آمل',
				name: 'آمل',
				coordinate: new Coordinates(36.4774551391602, 52.3558349609375)
			},
			{
				id: 'بابل',
				name: 'بابل',
				coordinate: new Coordinates(36.5211944580078, 52.6759300231934)
			},
			{
				id: 'بابلسر',
				name: 'بابلسر',
				coordinate: new Coordinates(36.6989364624023, 52.6493377685547)
			},
			{
				id: 'بلده',
				name: 'بلده',
				coordinate: new Coordinates(36.2012214660645, 51.8061027526855)
			},
			{
				id: 'بهشهر',
				name: 'بهشهر',
				coordinate: new Coordinates(36.6955413818359, 53.5346412658691)
			},
			{
				id: 'بهنمير',
				name: 'بهنمير',
				coordinate: new Coordinates(36.6702041625977, 52.7622756958008)
			},
			{
				id: 'پل سفيد',
				name: 'پل سفيد',
				coordinate: new Coordinates(36.1136665344238, 53.0577507019043)
			},
			{
				id: 'پول',
				name: 'پول',
				coordinate: new Coordinates(36.395580291748, 51.5897941589356)
			},
			{
				id: 'تنكابن',
				name: 'تنكابن',
				coordinate: new Coordinates(36.8151397705078, 50.8743629455566)
			},
			{
				id: 'جويبار',
				name: 'جويبار',
				coordinate: new Coordinates(36.6410064697266, 52.8998260498047)
			},
			{
				id: 'چالوس',
				name: 'چالوس',
				coordinate: new Coordinates(36.6539878845215, 51.4244689941406)
			},
			{
				id: 'چمستان',
				name: 'چمستان',
				coordinate: new Coordinates(36.4823989868164, 52.1211318969727)
			},
			{
				id: 'خرم آباد',
				name: 'خرم آباد',
				coordinate: new Coordinates(36.7863121032715, 50.867374420166)
			},
			{
				id: 'خليل شهر',
				name: 'خليل شهر',
				coordinate: new Coordinates(36.7017631530762, 53.6395721435547)
			},
			{
				id: 'خوش رودپي',
				name: 'خوش رودپي',
				coordinate: new Coordinates(36.3714599609375, 52.5656929016113)
			},
			{
				id: 'دابودشت',
				name: 'دابودشت',
				coordinate: new Coordinates(36.4806632995605, 52.4520378112793)
			},
			{
				id: 'رامسر',
				name: 'رامسر',
				coordinate: new Coordinates(36.9159889221191, 50.6623344421387)
			},
			{
				id: 'رستمكلا',
				name: 'رستمكلا',
				coordinate: new Coordinates(36.6780815124512, 53.4260444641113)
			},
			{
				id: 'رويان',
				name: 'رويان',
				coordinate: new Coordinates(36.5703659057617, 51.9688606262207)
			},
			{
				id: 'رينه',
				name: 'رينه',
				coordinate: new Coordinates(35.8819885253906, 52.169750213623)
			},
			{
				id: 'زرگر محله',
				name: 'زرگر محله',
				coordinate: new Coordinates(36.516185760498, 52.5744132995605)
			},
			{
				id: 'زيرآب',
				name: 'زيرآب',
				coordinate: new Coordinates(36.1796417236328, 52.9746856689453)
			},
			{
				id: 'ساري',
				name: 'ساري',
				coordinate: new Coordinates(36.5668830871582, 53.0600166320801)
			},
			{
				id: 'سرخرود',
				name: 'سرخرود',
				coordinate: new Coordinates(36.6765747070312, 52.4567909240723)
			},
			{
				id: 'سلمان شهر',
				name: 'سلمان شهر',
				coordinate: new Coordinates(36.6990242004395, 51.1999549865723)
			},
			{
				id: 'سورك',
				name: 'سورك',
				coordinate: new Coordinates(36.593921661377, 53.2116737365723)
			},
			{
				id: 'شيرگاه',
				name: 'شيرگاه',
				coordinate: new Coordinates(36.2899513244629, 52.8809509277344)
			},
			{
				id: 'شيرود',
				name: 'شيرود',
				coordinate: new Coordinates(36.8479499816895, 50.7905311584473)
			},
			{
				id: 'عباس آباد',
				name: 'عباس آباد',
				coordinate: new Coordinates(36.7212333679199, 51.1159706115723)
			},
			{
				id: 'فريدونكنار',
				name: 'فريدونكنار',
				coordinate: new Coordinates(36.682804107666, 52.5166854858398)
			},
			{
				id: 'فريم',
				name: 'فريم',
				coordinate: new Coordinates(36.174186706543, 53.2669219970703)
			},
			{
				id: 'قائم شهر',
				name: 'قائم شهر',
				coordinate: new Coordinates(36.4643516540527, 52.8650817871094)
			},
			{
				id: 'كتالم وسادات شهر',
				name: 'كتالم وسادات شهر',
				coordinate: new Coordinates(36.8780632019043, 50.7169723510742)
			},
			{
				id: 'كلارآباد',
				name: 'كلارآباد',
				coordinate: new Coordinates(36.6914291381836, 51.2626266479492)
			},
			{
				id: 'كلاردشت',
				name: 'كلاردشت',
				coordinate: new Coordinates(36.4936943054199, 51.1449546813965)
			},
			{
				id: 'كله بست',
				name: 'كله بست',
				coordinate: new Coordinates(36.6352348327637, 52.6267356872559)
			},
			{
				id: 'كوهي خيل',
				name: 'كوهي خيل',
				coordinate: new Coordinates(36.6858100891113, 52.9069900512695)
			},
			{
				id: 'كياسر',
				name: 'كياسر',
				coordinate: new Coordinates(36.2379150390625, 53.5394058227539)
			},
			{
				id: 'كياكلا',
				name: 'كياكلا',
				coordinate: new Coordinates(36.5818748474121, 52.8148193359375)
			},
			{
				id: 'گتاب',
				name: 'گتاب',
				coordinate: new Coordinates(36.4165954589844, 52.6565132141113)
			},
			{
				id: 'گزنك',
				name: 'گزنك',
				coordinate: new Coordinates(35.9029426574707, 52.2192497253418)
			},
			{
				id: 'گلوگاه',
				name: 'گلوگاه',
				coordinate: new Coordinates(36.7251358032227, 53.8110504150391)
			},
			{
				id: 'محمودآباد',
				name: 'محمودآباد',
				coordinate: new Coordinates(36.6314392089844, 52.252368927002)
			},
			{
				id: 'مرزن آباد',
				name: 'مرزن آباد',
				coordinate: new Coordinates(36.4463157653809, 51.2955932617188)
			},
			{
				id: 'مرزيكلا',
				name: 'مرزيكلا',
				coordinate: new Coordinates(36.3640480041504, 52.7358512878418)
			},
			{
				id: 'نشتارود',
				name: 'نشتارود',
				coordinate: new Coordinates(36.7482299804688, 51.0351104736328)
			},
			{
				id: 'نكا',
				name: 'نكا',
				coordinate: new Coordinates(36.6518745422363, 53.2936477661133)
			},
			{
				id: 'نور',
				name: 'نور',
				coordinate: new Coordinates(36.5730743408203, 52.0158805847168)
			},
			{
				id: 'نوشهر',
				name: 'نوشهر',
				coordinate: new Coordinates(36.6470832824707, 51.4998435974121)
			}
		]
	},
	{
		name: 'مركزي',
		cities: [
			{
				id: 'اراك',
				name: 'اراك',
				coordinate: new Coordinates(34.093448638916, 49.7220993041992)
			},
			{
				id: 'آستانه',
				name: 'آستانه',
				coordinate: new Coordinates(33.8884582519531, 49.3520202636719)
			},
			{
				id: 'آشتيان',
				name: 'آشتيان',
				coordinate: new Coordinates(34.5235900878906, 50.0057945251465)
			},
			{
				id: 'پرندك',
				name: 'پرندك',
				coordinate: new Coordinates(35.3595085144043, 50.6805763244629)
			},
			{
				id: 'تفرش',
				name: 'تفرش',
				coordinate: new Coordinates(34.6850204467773, 50.0226287841797)
			},
			{
				id: 'توره',
				name: 'توره',
				coordinate: new Coordinates(34.0461235046387, 49.2887992858887)
			},
			{
				id: 'جاورسيان',
				name: 'جاورسيان',
				coordinate: new Coordinates(34.2566108703613, 49.3269882202148)
			},
			{
				id: 'خشكرود',
				name: 'خشكرود',
				coordinate: new Coordinates(35.3995666503906, 50.3356056213379)
			},
			{
				id: 'خمين',
				name: 'خمين',
				coordinate: new Coordinates(33.6410751342773, 50.0803070068359)
			},
			{
				id: 'خنداب',
				name: 'خنداب',
				coordinate: new Coordinates(34.3834495544434, 49.1889419555664)
			},
			{
				id: 'داودآباد',
				name: 'داودآباد',
				coordinate: new Coordinates(34.2934913635254, 49.8550987243652)
			},
			{
				id: 'دليجان',
				name: 'دليجان',
				coordinate: new Coordinates(33.9903564453125, 50.6816558837891)
			},
			{
				id: 'رازقان',
				name: 'رازقان',
				coordinate: new Coordinates(35.3310890197754, 49.955924987793)
			},
			{
				id: 'زاويه',
				name: 'زاويه',
				coordinate: new Coordinates(35.3721046447754, 50.5703544616699)
			},
			{
				id: 'ساروق',
				name: 'ساروق',
				coordinate: new Coordinates(34.4079322814941, 49.5076866149902)
			},
			{
				id: 'ساوه',
				name: 'ساوه',
				coordinate: new Coordinates(35.025333404541, 50.3649215698242)
			},
			{
				id: 'سنجان',
				name: 'سنجان',
				coordinate: new Coordinates(34.0509986877441, 49.6242637634277)
			},
			{
				id: 'شازند',
				name: 'شازند',
				coordinate: new Coordinates(33.9337005615234, 49.4108772277832)
			},
			{
				id: 'شهرجديدمهاجران',
				name: 'شهرجديدمهاجران',
				coordinate: new Coordinates(34.0518798828125, 49.4342803955078)
			},
			{
				id: 'غرق آباد',
				name: 'غرق آباد',
				coordinate: new Coordinates(35.1010589599609, 49.8305435180664)
			},
			{
				id: 'فرمهين',
				name: 'فرمهين',
				coordinate: new Coordinates(34.4960289001465, 49.6843719482422)
			},
			{
				id: 'قورچي باشي',
				name: 'قورچي باشي',
				coordinate: new Coordinates(33.6747779846191, 49.8774337768555)
			},
			{
				id: 'كرهرود',
				name: 'كرهرود',
				coordinate: new Coordinates(34.0637016296387, 49.6500358581543)
			},
			{
				id: 'كميجان',
				name: 'كميجان',
				coordinate: new Coordinates(34.719123840332, 49.3223342895508)
			},
			{
				id: 'مأمونيه',
				name: 'مأمونيه',
				coordinate: new Coordinates(35.3109397888184, 50.4972496032715)
			},
			{
				id: 'محلات',
				name: 'محلات',
				coordinate: new Coordinates(33.9083824157715, 50.4541435241699)
			},
			{
				id: 'ميلاجرد',
				name: 'ميلاجرد',
				coordinate: new Coordinates(34.6212730407715, 49.2095832824707)
			},
			{
				id: 'نراق',
				name: 'نراق',
				coordinate: new Coordinates(34.0117111206055, 50.8379707336426)
			},
			{
				id: 'نوبران',
				name: 'نوبران',
				coordinate: new Coordinates(35.1299438476562, 49.709228515625)
			},
			{
				id: 'نيمور',
				name: 'نيمور',
				coordinate: new Coordinates(33.8869171142578, 50.5736312866211)
			},
			{
				id: 'هندودر',
				name: 'هندودر',
				coordinate: new Coordinates(33.7794609069824, 49.2308654785156)
			}
		]
	},
	{
		name: 'هرمزگان',
		cities: [
			{
				id: 'ابوموسي',
				name: 'ابوموسي',
				coordinate: new Coordinates(25.8834629058838, 55.0298538208008)
			},
			{
				id: 'بستك',
				name: 'بستك',
				coordinate: new Coordinates(27.1946144104004, 54.3667945861816)
			},
			{
				id: 'بندرجاسك',
				name: 'بندرجاسك',
				coordinate: new Coordinates(25.6569957733154, 57.8006324768066)
			},
			{
				id: 'بندرچارك',
				name: 'بندرچارك',
				coordinate: new Coordinates(26.7334976196289, 54.2734146118164)
			},
			{
				id: 'بندرعباس',
				name: 'بندرعباس',
				coordinate: new Coordinates(27.1926517486572, 56.2914657592773)
			},
			{
				id: 'بندرلنگه',
				name: 'بندرلنگه',
				coordinate: new Coordinates(26.5475330352783, 54.8889236450195)
			},
			{
				id: 'بيكاه',
				name: 'بيكاه',
				coordinate: new Coordinates(27.3489151000977, 57.1773262023926)
			},
			{
				id: 'پارسيان',
				name: 'پارسيان',
				coordinate: new Coordinates(27.2039394378662, 53.042724609375)
			},
			{
				id: 'تخت',
				name: 'تخت',
				coordinate: new Coordinates(27.5003719329834, 56.6346778869629)
			},
			{
				id: 'جناح',
				name: 'جناح',
				coordinate: new Coordinates(27.0181541442871, 54.2859954833984)
			},
			{
				id: 'حاجي آباد',
				name: 'حاجي آباد',
				coordinate: new Coordinates(28.309211730957, 55.9016189575195)
			},
			{
				id: 'خمير',
				name: 'خمير',
				coordinate: new Coordinates(26.9512062072754, 55.5879020690918)
			},
			{
				id: 'درگهان',
				name: 'درگهان',
				coordinate: new Coordinates(26.9641761779785, 56.0662231445312)
			},
			{
				id: 'دهبارز',
				name: 'دهبارز',
				coordinate: new Coordinates(27.4419956207275, 57.1975021362305)
			},
			{
				id: 'رويدر',
				name: 'رويدر',
				coordinate: new Coordinates(27.4655685424805, 55.417537689209)
			},
			{
				id: 'زيارتعلي',
				name: 'زيارتعلي',
				coordinate: new Coordinates(27.7399959564209, 57.2263412475586)
			},
			{
				id: 'سردشت بشاگرد',
				name: 'سردشت بشاگرد',
				coordinate: new Coordinates(26.4551849365234, 57.9012184143066)
			},
			{
				id: 'سرگز',
				name: 'سرگز',
				coordinate: new Coordinates(27.9431838989258, 56.6569786071777)
			},
			{
				id: 'سندرك',
				name: 'سندرك',
				coordinate: new Coordinates(26.836784362793, 57.4265403747559)
			},
			{
				id: 'سوزا',
				name: 'سوزا',
				coordinate: new Coordinates(26.7803153991699, 56.0650024414062)
			},
			{
				id: 'سيريك',
				name: 'سيريك',
				coordinate: new Coordinates(26.521110534668, 57.1092872619629)
			},
			{
				id: 'فارغان',
				name: 'فارغان',
				coordinate: new Coordinates(28.0091457366943, 56.252197265625)
			},
			{
				id: 'فين',
				name: 'فين',
				coordinate: new Coordinates(27.6335906982422, 55.8821067810059)
			},
			{
				id: 'قشم',
				name: 'قشم',
				coordinate: new Coordinates(26.9489421844482, 56.2728805541992)
			},
			{
				id: 'قلعه قاضي',
				name: 'قلعه قاضي',
				coordinate: new Coordinates(27.4446678161621, 56.5446128845215)
			},
			{
				id: 'كنگ',
				name: 'كنگ',
				coordinate: new Coordinates(26.5961799621582, 54.9365730285645)
			},
			{
				id: 'كوشكنار',
				name: 'كوشكنار',
				coordinate: new Coordinates(27.2517395019531, 52.867359161377)
			},
			{
				id: 'كيش',
				name: 'كيش',
				coordinate: new Coordinates(26.5334243774414, 53.9738464355469)
			},
			{
				id: 'گوهران',
				name: 'گوهران',
				coordinate: new Coordinates(26.5946273803711, 57.8975868225098)
			},
			{
				id: 'ميناب',
				name: 'ميناب',
				coordinate: new Coordinates(27.0975875854492, 57.0741500854492)
			},
			{
				id: 'هرمز',
				name: 'هرمز',
				coordinate: new Coordinates(27.0911407470703, 56.4573974609375)
			},
			{
				id: 'هشتبندي',
				name: 'هشتبندي',
				coordinate: new Coordinates(27.1645679473877, 57.4512367248535)
			}
		]
	},
	{
		name: 'همدان',
		cities: [
			{
				id: 'ازندريان',
				name: 'ازندريان',
				coordinate: new Coordinates(34.5016326904297, 48.6929626464844)
			},
			{
				id: 'اسدآباد',
				name: 'اسدآباد',
				coordinate: new Coordinates(34.7853584289551, 48.1216621398926)
			},
			{
				id: 'برزول',
				name: 'برزول',
				coordinate: new Coordinates(34.2135581970215, 48.2609710693359)
			},
			{
				id: 'بهار',
				name: 'بهار',
				coordinate: new Coordinates(34.8907051086426, 48.4408836364746)
			},
			{
				id: 'تويسركان',
				name: 'تويسركان',
				coordinate: new Coordinates(34.5490417480469, 48.4481163024902)
			},
			{
				id: 'جورقان',
				name: 'جورقان',
				coordinate: new Coordinates(34.8818054199219, 48.5527992248535)
			},
			{
				id: 'جوكار',
				name: 'جوكار',
				coordinate: new Coordinates(34.4316062927246, 48.6860961914063)
			},
			{
				id: 'دمق',
				name: 'دمق',
				coordinate: new Coordinates(35.4370346069336, 48.8220558166504)
			},
			{
				id: 'رزن',
				name: 'رزن',
				coordinate: new Coordinates(35.3906478881836, 49.0351142883301)
			},
			{
				id: 'زنگنه',
				name: 'زنگنه',
				coordinate: new Coordinates(34.1548385620117, 49.0084114074707)
			},
			{
				id: 'سامن',
				name: 'سامن',
				coordinate: new Coordinates(34.2092552185059, 48.7035446166992)
			},
			{
				id: 'سركان',
				name: 'سركان',
				coordinate: new Coordinates(34.594482421875, 48.4478874206543)
			},
			{
				id: 'شيرين سو',
				name: 'شيرين سو',
				coordinate: new Coordinates(35.4927253723145, 48.450611114502)
			},
			{
				id: 'صالح آباد',
				name: 'صالح آباد',
				coordinate: new Coordinates(34.9220886230469, 48.343074798584)
			},
			{
				id: 'فامنين',
				name: 'فامنين',
				coordinate: new Coordinates(35.1153755187988, 48.9722671508789)
			},
			{
				id: 'فرسفج',
				name: 'فرسفج',
				coordinate: new Coordinates(34.4860610961914, 48.2883186340332)
			},
			{
				id: 'فيروزان',
				name: 'فيروزان',
				coordinate: new Coordinates(34.3605575561523, 48.1161575317383)
			},
			{
				id: 'قروه در جزين',
				name: 'قروه در جزين',
				coordinate: new Coordinates(35.3119659423828, 49.1000518798828)
			},
			{
				id: 'قهاوند',
				name: 'قهاوند',
				coordinate: new Coordinates(34.8583946228027, 49.003360748291)
			},
			{
				id: 'كبودرآهنگ',
				name: 'كبودرآهنگ',
				coordinate: new Coordinates(35.2092437744141, 48.7248687744141)
			},
			{
				id: 'گل تپه',
				name: 'گل تپه',
				coordinate: new Coordinates(35.2201385498047, 48.2053947448731)
			},
			{
				id: 'گيان',
				name: 'گيان',
				coordinate: new Coordinates(34.1770248413086, 48.244068145752)
			},
			{
				id: 'لالجين',
				name: 'لالجين',
				coordinate: new Coordinates(34.9735946655273, 48.4783973693848)
			},
			{
				id: 'مريانج',
				name: 'مريانج',
				coordinate: new Coordinates(34.8318939208984, 48.4632682800293)
			},
			{
				id: 'ملاير',
				name: 'ملاير',
				coordinate: new Coordinates(34.2973175048828, 48.8165473937988)
			},
			{
				id: 'نهاوند',
				name: 'نهاوند',
				coordinate: new Coordinates(34.1682090759277, 48.3755073547363)
			},
			{
				id: 'همدان',
				name: 'همدان',
				coordinate: new Coordinates(34.7918128967285, 48.5261459350586)
			}
		]
	},
	{
		name: 'يزد',
		cities: [
			{
				id: 'ابركوه',
				name: 'ابركوه',
				coordinate: new Coordinates(31.1302242279053, 53.2794494628906)
			},
			{
				id: 'احمدآباد',
				name: 'احمدآباد',
				coordinate: new Coordinates(32.357105255127, 53.9913711547852)
			},
			{
				id: 'اردكان',
				name: 'اردكان',
				coordinate: new Coordinates(32.3069229125977, 54.0185623168945)
			},
			{
				id: 'اشكذر',
				name: 'اشكذر',
				coordinate: new Coordinates(32.000244140625, 54.2068786621094)
			},
			{
				id: 'بافق',
				name: 'بافق',
				coordinate: new Coordinates(31.6040916442871, 55.3963813781738)
			},
			{
				id: 'بفروئيه',
				name: 'بفروئيه',
				coordinate: new Coordinates(32.2723083496094, 53.9968109130859)
			},
			{
				id: 'بهاباد',
				name: 'بهاباد',
				coordinate: new Coordinates(31.8679790496826, 56.0264892578125)
			},
			{
				id: 'تفت',
				name: 'تفت',
				coordinate: new Coordinates(31.7426567077637, 54.2077140808105)
			},
			{
				id: 'حميديا',
				name: 'حميديا',
				coordinate: new Coordinates(31.8193664550781, 54.3982772827148)
			},
			{
				id: 'خضرآباد',
				name: 'خضرآباد',
				coordinate: new Coordinates(31.8654651641846, 53.9523773193359)
			},
			{
				id: 'ديهوك',
				name: 'ديهوك',
				coordinate: new Coordinates(33.2803497314453, 57.5159683227539)
			},
			{
				id: 'زارچ',
				name: 'زارچ',
				coordinate: new Coordinates(31.9842662811279, 54.2426147460938)
			},
			{
				id: 'شاهديه',
				name: 'شاهديه',
				coordinate: new Coordinates(31.9430103302002, 54.2801551818848)
			},
			{
				id: 'طبس',
				name: 'طبس',
				coordinate: new Coordinates(33.5751876831055, 56.9353332519531)
			},
			{
				id: 'عشق آباد',
				name: 'عشق آباد',
				coordinate: new Coordinates(34.3663558959961, 56.9283180236816)
			},
			{
				id: 'عقدا',
				name: 'عقدا',
				coordinate: new Coordinates(32.439525604248, 53.6316566467285)
			},
			{
				id: 'مروست',
				name: 'مروست',
				coordinate: new Coordinates(30.4653854370117, 54.2107696533203)
			},
			{
				id: 'مهردشت',
				name: 'مهردشت',
				coordinate: new Coordinates(31.0231647491455, 53.3557357788086)
			},
			{
				id: 'مهريز',
				name: 'مهريز',
				coordinate: new Coordinates(31.5574188232422, 54.437816619873)
			},
			{
				id: 'ميبد',
				name: 'ميبد',
				coordinate: new Coordinates(32.2422523498535, 54.0181427001953)
			},
			{
				id: 'ندوشن',
				name: 'ندوشن',
				coordinate: new Coordinates(32.029052734375, 53.5485153198242)
			},
			{
				id: 'نير',
				name: 'نير',
				coordinate: new Coordinates(31.4848594665527, 54.1288185119629)
			},
			{
				id: 'هرات',
				name: 'هرات',
				coordinate: new Coordinates(30.0508155822754, 54.3697013854981)
			},
			{
				id: 'يزد',
				name: 'يزد',
				coordinate: new Coordinates(31.8835220336914, 54.3477401733398)
			}
		]
	}
];


